export const DataTestIds = {
    COMMON: {
        HEADER_LOGO: 'header-logo',
        COMMUNITY_HEADER: {
            ACCOUNT_TRIGGER: 'community-account-menu-trigger',
            ACCOUNT_MENU: 'community-account-menu',
            HOME: 'community-header-home',
            MEMBERS: 'community-header-members',
            CONNECTIONS: 'community-header-connections',
            BOOKMARKS: 'community-header-bookmarks',
        },
        APP_HYDRATED: 'app-hydrated',
        SIDEBAR: {
            USER_AVATAR: 'profile-avatar',
            CONTAINER: 'sidebar',
            DASHBOARD: 'dashboard-btn',
            COURSES: 'courses-btn',
            CALENDAR: 'calendar-btn',
            LIVE_WORKSHOPS: 'live-workshops-btn',
            RECORDED_EVENTS: 'recorded-events-btn',
            TOOLS_TEMPLATES: 'tools-templates-btn',
            DEALS_DISCOUNTS: 'deals-discounts-btn',
            ONE_ON_ONE_COACHING: 'coaching-btn',
            SCENARIOS: 'scenarios',
            COMMUNITY: 'community-btn',
        },
        SETTING_PANEL: {
            PANEL: 'setting-panel',
            MOBILE_TRIGGER: 'settings-mobile-menu-trigger',
            MOBILE_DROPDOWN: 'settings-mobile-menu-dropdown',
        },
        AI_HELP: {
            OPEN_BUTTON: 'ai-help-open-button',
            OPTIONS_BUTTON: 'ai-help-options-button',
            ESCALATE_BUTTON: 'ai-help-escalate-button',
            ESCALATE_DIALOG: 'ai-help-escalate-dialog',
            ESCALATE_REASON_INPUT: 'ai-help-escalate-reason-input',
            ESCALATE_CONFIRM_BUTTON: 'ai-help-escalate-confirm-button',
            ESCALATE_CANCEL_BUTTON: 'ai-help-escalate-cancel-button',
            HISTORY_BUTTON: 'ai-help-history-button',
            HISTORY_ITEM: 'ai-help-history-item',
            NEW_CHAT_BUTTON: 'ai-help-new-chat-button',
        },
        CHAT: {
            PANEL: 'chat-panel',
            OVERLAY: 'chat-overlay',
            HEADER_TITLE: 'chat-header-title',
            HEADER_CONTEXT: 'chat-header-context',
            CLOSE_BUTTON: 'chat-close-button',
            MESSAGES: 'chat-messages',
            EMPTY_STATE: 'chat-empty-state',
            EMPTY_STATE_TITLE: 'chat-empty-state-title',
            EMPTY_STATE_DESCRIPTION: 'chat-empty-state-description',
            PROMPT_CHIP: 'chat-prompt-chip',
            INPUT: 'chat-input',
            SEND_BUTTON: 'chat-send-button',
            ATTACHMENT_INPUT: 'chat-attachment-input',
            THINKING_INDICATOR: 'chat-thinking-indicator',
            ACTIVITY_LABEL: 'chat-activity-label',
            STOP_BUTTON: 'chat-stop-button',
            RETRY_BUTTON: 'chat-retry-button',
            DRAFT_HINT: 'chat-draft-hint',
            MESSAGE: 'chat-message',
            MESSAGE_AVATAR: 'chat-message-avatar',
            MESSAGE_BUBBLE: 'chat-message-bubble',
            MESSAGE_TEXT: 'chat-message-text',
            ATTACHMENT_DOWNLOAD_LINK: 'chat-attachment-download-link',
            INBOX_PAGE: 'chat-inbox-page',
            INBOX_SIDEBAR: 'chat-inbox-sidebar',
            INBOX_ITEM: 'chat-inbox-item',
            INBOX_EMPTY: 'chat-inbox-empty',
            INBOX_LOAD_MORE: 'chat-inbox-load-more',
            INBOX_MOBILE_BACK: 'chat-inbox-mobile-back',
        },
        UPCOMING_SESSIONS: {
            RESCHEDULE_BUTTON: 'upcoming-sessions-reschedule-button',
            RESCHEDULE_CONFIRM: 'upcoming-sessions-reschedule-confirm',
            RESCHEDULE_START_INPUT: 'upcoming-sessions-reschedule-start-input',
            CANCEL_BUTTON: 'upcoming-sessions-cancel-button',
            CANCEL_REASON_INPUT: 'cancel-reason-input',
            CANCEL_CONFIRM_BTN: 'cancel-confirm-btn',
            REFUND_STATUS: 'upcoming-sessions-refund-status',
            SESSION_TIME: 'upcoming-sessions-session-time',
        },
        HEADER_NOTIFICATIONS: {
            TRIGGER: 'header-notifications-trigger',
            PANEL: 'header-notifications-panel',
            TABS: 'header-notification-tabs',
            TAB_ALL: 'header-notification-tab-all',
            TAB_ALERTS: 'header-notification-tab-alerts',
            TAB_SCENARIOS: 'header-notification-tab-scenarios',
            FILTER_TRIGGER: 'header-notification-filter-trigger',
            FILTER_ALL: 'header-notification-filter-all',
            FILTER_UNREAD: 'header-notification-filter-unread',
            FILTER_ARCHIVED: 'header-notification-filter-archived',
            MORE_TRIGGER: 'header-notification-more-trigger',
            MARK_ALL_READ: 'header-notification-mark-all-read',
            ARCHIVE_ALL: 'header-notification-archive-all',
            ITEM: 'header-notification-item',
            ITEM_UNREAD_DOT: 'header-notification-item-unread-dot',
            ITEM_MARK_READ: 'header-notification-item-mark-read',
            ITEM_MARK_UNREAD: 'header-notification-item-mark-unread',
            ITEM_ARCHIVE: 'header-notification-item-archive',
            ITEM_UNARCHIVE: 'header-notification-item-unarchive',
            EMPTY: 'header-notifications-empty',
            UNREAD_COUNTER: 'header-notifications-unread-counter',
            LIST_SCROLL: 'header-notifications-list-scroll',
        },
        SETTINGS: {
            PROFILE: 'profile-btn',
            AVAILABILITY: 'availability-btn',
            SECURITY: 'security-btn',
            NOTIFICATIONS: 'notifications-btn',
            BILLING: 'billing-btn',
            INTEGRATIONS: 'integrations-btn',
            DELETE_ACCOUNT: 'delete-account-btn',
            MANAGE_ACCOUNT: 'manage-account-btn',
            MY_MBA: 'my-mba-btn',
        },
        SECURITY: {
            CURRENT_PWD_INPUT: 'currentPassword-input',
            CURRENT_PWD_ERROR: 'currentPassword-error',
            NEW_PASSWORD_INPUT: 'newPassword-input',
            NEW_PASSWORD_ERROR: 'newPassword-error',
            CONFIRM_PASSWORD_INPUT: 'confirmPassword-input',
            CONFIRM_PASSWORD_ERROR: 'confirmPassword-error',
            CHANGE_PASSWORD_BTN: 'change-password-btn',
            FORM_ERROR: 'change-password-form-error',
            SUCCESS_MODAL: 'password-update-success',
            MFA: {
                SECTION: 'mfa-settings-section',
                STATUS: 'mfa-settings-status',
                LOADING: 'mfa-settings-loading',
                ERROR: 'mfa-settings-error',
                TOTP_CARD: 'mfa-totp-card',
                TOTP_STATE: 'mfa-totp-state',
                TOTP_ENROLL: 'mfa-totp-enroll',
                TOTP_CONTINUE: 'mfa-totp-continue',
                TOTP_REMOVE: 'mfa-totp-remove',
                EMAIL_CARD: 'mfa-email-card',
                EMAIL_STATE: 'mfa-email-state',
                EMAIL_ENROLL: 'mfa-email-enroll',
                EMAIL_CONTINUE: 'mfa-email-continue',
                EMAIL_REMOVE: 'mfa-email-remove',
                EMAIL_RESEND: 'mfa-email-resend',
                EMAIL_SETUP: 'mfa-email-setup',
                EMAIL_SEND: 'mfa-email-send',
                EMAIL_CHANGE: 'mfa-email-change',
                EMAIL_INVALID: 'mfa-email-invalid',
                EMAIL_TRY_AGAIN: 'mfa-email-try-again',
                EMAIL_MANAGE: 'mfa-email-manage',
                EMAIL_REMOVE_CONFIRM: 'mfa-email-remove-confirm',
                EMAIL_ADDED: 'mfa-email-added',
                EMAIL_LAST_USED: 'mfa-email-last-used',
                EMAIL_CLOSE: 'mfa-email-close',
                QR: 'mfa-totp-qr',
                SECRET: 'mfa-totp-secret',
                CODE_INPUT: 'mfa-code-input',
                CONFIRM: 'mfa-confirm',
                CANCEL: 'mfa-cancel',
                BACKUP_CODES: 'mfa-backup-codes',
                BACKUP_CODE: 'mfa-backup-code',
                COPY_BACKUP: 'mfa-copy-backup-codes',
                DOWNLOAD_BACKUP: 'mfa-download-backup-codes',
                PRINT_BACKUP: 'mfa-print-backup-codes',
                BACKUP_GENERATE: 'mfa-backup-generate',
                REMAINING_BACKUP: 'mfa-remaining-backup-codes',
                REGENERATE: 'mfa-regenerate-backup',
                MANAGE: 'mfa-manage',
                TURN_ON: 'mfa-turn-on',
                SAVE_CHANGES: 'mfa-save-changes',
                DISABLE_ALL: 'mfa-disable-all',
                DISABLE_CONFIRM: 'mfa-disable-confirm',
                REAUTH_DIALOG: 'mfa-reauth-dialog',
                REAUTH_PASSWORD: 'mfa-reauth-password',
                OAUTH_CONTINUE: 'mfa-oauth-continue',
                OAUTH_OTHER_ACCOUNT: 'mfa-oauth-other-account',
                CHOOSE_METHOD: 'mfa-choose-method',
                CHOOSE_TOTP: 'mfa-choose-totp',
                CHOOSE_SMS: 'mfa-choose-sms',
                CHOOSE_EMAIL: 'mfa-choose-email',
                CHOOSE_PASSKEY: 'mfa-choose-passkey',
                EXISTING_FACTOR_CODE: 'mfa-existing-factor-code',
                EXISTING_FACTOR: 'mfa-existing-factor',
                SETUP_DIALOG: 'mfa-setup-dialog',
                TOTP_INTRO_CONTINUE: 'mfa-totp-intro-continue',
                TOTP_MANUAL: 'mfa-totp-manual',
                TOTP_BACK: 'mfa-totp-back',
                TOTP_INVALID: 'mfa-totp-invalid',
                TOTP_SETUP_AGAIN: 'mfa-totp-setup-again',
                TOTP_TRY_AGAIN: 'mfa-totp-try-again',
                TOTP_MANAGE: 'mfa-totp-manage',
                TOTP_CLOSE: 'mfa-totp-close',
                TOTP_REPLACE: 'mfa-totp-replace',
                TOTP_REMOVE_CONFIRM: 'mfa-totp-remove-confirm',
                TOTP_APP_NAME: 'mfa-totp-app-name',
                TOTP_APP_NAME_EDIT: 'mfa-totp-app-name-edit',
                TOTP_ADDED: 'mfa-totp-added',
                TOTP_LAST_USED: 'mfa-totp-last-used',
                NEW_PRIMARY: 'mfa-new-primary',
                SMS_SETUP: 'mfa-sms-setup',
                SMS_PHONE: 'mfa-sms-phone',
                SMS_DIAL: 'mfa-sms-dial',
                SMS_SEND: 'mfa-sms-send',
                SMS_CHANGE_NUMBER: 'mfa-sms-change-number',
                SMS_RESEND: 'mfa-sms-resend',
                SMS_INVALID: 'mfa-sms-invalid',
                SMS_TRY_AGAIN: 'mfa-sms-try-again',
                SMS_MANAGE: 'mfa-sms-manage',
                SMS_REMOVE: 'mfa-sms-remove',
                SMS_REMOVE_CONFIRM: 'mfa-sms-remove-confirm',
                SMS_ADDED: 'mfa-sms-added',
                SMS_LAST_USED: 'mfa-sms-last-used',
                SMS_CLOSE: 'mfa-sms-close',
                ADD_ANOTHER_METHOD: 'mfa-add-another-method',
                PASSKEY_SETUP: 'mfa-passkey-setup',
                PASSKEY_CREATE: 'mfa-passkey-create',
                PASSKEY_CREATING: 'mfa-passkey-creating',
                PASSKEY_WAITING: 'mfa-passkey-waiting',
                PASSKEY_INVALID: 'mfa-passkey-invalid',
                PASSKEY_TRY_AGAIN: 'mfa-passkey-try-again',
                PASSKEY_MANAGE: 'mfa-passkey-manage',
                PASSKEY_CARD: 'mfa-passkey-card',
                PASSKEY_DELETE: 'mfa-passkey-delete',
                PASSKEY_ADD_ANOTHER: 'mfa-passkey-add-another',
                PASSKEY_REMOVE_ALL: 'mfa-passkey-remove-all',
                PASSKEY_REMOVE_CONFIRM: 'mfa-passkey-remove-confirm',
                PASSKEY_CLOSE: 'mfa-passkey-close',
            },
            SESSIONS: {
                SECTION: 'security-sessions',
                LOADING: 'security-sessions-loading',
                ERROR: 'security-sessions-error',
                SIGN_OUT_INACTIVE: 'security-sessions-sign-out-inactive',
                ROW: 'security-session-row',
                SIGN_OUT: 'security-session-sign-out',
                SIGN_OUT_CURRENT: 'security-session-sign-out-current',
            },
        },
        TOAST: 'toast',
        IMAGE_INPUT_ERROR: 'image-input-error',
        IMAGE_INPUT_PREVIEW: 'image-input-preview',
        IMAGE_INPUT_EDIT: 'image-input-edit',
        IMAGE_INPUT_REMOVE: 'image-input-remove',
        FORM_ERROR_SUMMARY: 'form-error-summary',
        FORM_ERROR_SUMMARY_ITEM: 'form-error-summary-item',
        MODAL_CLOSE_ICON: 'modal-close-icon',
        BACK_BUTTON: 'back-btn',
        LANGUAGE_SWITCHER: {
            TRIGGER: 'language-switcher-trigger',
            OPTION_PREFIX: 'language-switcher-option',
        },
        LABEL_PILL: 'label-pill',
        PROGRESS_BAR_TITLE: 'progress-title',
        PROGRESS_BAR: 'progress-bar',
        DROPDOWN: 'dropdown',
        DROPDOWN_ITEM: 'dropdown-item',
        MULTI_SELECT_ITEM: 'multi-select-item',
        MULTI_SELECT_LIST: 'multi-select-list',
        MULTI_SELECT_STATUS: 'multi-select-status',
        MULTI_SELECT_SEARCH_INPUT: 'multi-select-search-input',
        MULTI_SELECT_TRIGGER: 'multi-select-trigger',
        MULTI_SELECT_CLEAR_ALL: 'multi-select-clear-all',
        MULTI_SELECT_CHIP: 'multi-select-chip',
        MULTI_SELECT_CHIP_REMOVE: 'multi-select-chip-remove',
        CALENDAR_DAY: 'calendar-day',
        CALENDAR_PREV_PERIOD: 'calendar-prev-period',
        CALENDAR_NEXT_PERIOD: 'calendar-next-period',
        CALENDAR_PERIOD_LABEL: 'calendar-period-label',
        SMALL_CALENDAR: 'small-calendar',
        TIME_SELECTOR: 'time-selector',
        COMPLETION_ICON: {
            INCOMPLETE: 'icon-incomplete',
            COMPLETE: 'icon-complete',
            HALF_COMPLETE: 'icon-half',
        },
        SESSION_SIDEBAR: {
            TITLE: 'session-title',
            DROPDOWN: 'session-dropdown',
            ITEM: 'session-item',
            SEARCH_INPUT: 'session-search-input',
            PROGRESS_INFO: 'session-progress-info',
        },
        CONTENT_AREA: {
            LEARNING_DESCRIPTION: 'learning-description',
            VIDEO_PLAYER: 'video-player',
            RESOURCE_NOT_FOUND: 'resource-not-found',
            RESOURCE_NOT_FOUND_RETRY: 'resource-not-found-retry-button',
            RESOURCE_NOT_FOUND_BACK: 'resource-not-found-back-button',
            /** The shared spinner a resource shows while its own read is in flight. */
            RESOURCE_LOADER: 'resource-loader',
        },
        CONTENT_FOOTER: {
            MARK_AS_COMPLETED: 'mark-complete-btn',
            MARK_AS_INCOMPLETE: 'mark-incomplete-btn',
            CONTINUE: 'continue-btn',
            DOWNLOAD: 'download-attachment-btn',
            OPEN_WORKSHEETS: 'open-worksheets-btn',
            WORKSHEETS_DIALOG: 'lesson-worksheets-dialog',
            DOWNLOAD_ALL: 'download-all-attachments-btn',
            CLOSE_DIALOG: 'close-attachments-dialog-btn',
        },
        CAROUSEL: 'carousel',
        CAROUSEL_CARD_LIST: 'carousel-card-list',
        CAROUSEL_PAGINATION_BULLET: 'carousel-pagination-bullet',
        HEADER_CATEGORY_LIST: 'header-category-list',
        AVATAR_INITIALS: 'avatar-initials',
        AVATAR_IMAGE: 'avatar-image',
        DEFAULT_AVATAR: 'default-avatar',
        CATEGORY_BUTTON: 'category-button',
        CATEGORY_BUTTON_LABEL: 'category-button-label',
        NEXT_ICON: 'next-icon',
        PREV_ICON: 'prev-icon',
        EMPTY_LIST_TEXT: 'empty-list-text',
        CARD_IMAGE: 'card-image',
        BOOKMARK_BUTTON: 'bookmark-button',
        PREMIUM_BADGE: 'premium-badge',
        MENTOR_SELECT_BUTTON: 'select-button',
    },
    MOBILE: {
        MENU_OPEN_BTN: 'mobile-menu-open-btn',
        MENU_CLOSE_BTN: 'mobile-menu-close',
        LOGIN_BTN: 'mobile-login-btn',
        SIGNUP_BTN: 'mobile-signup-btn',
        DASHBOARD_BTN: 'mobile-dashboard-btn',
    },
    COOKIE_CONSENT: {
        SETTINGS_BUTTON: 'cookie-consent-settings-button',
        FOOTER_SETTINGS_BUTTON: 'cookie-consent-footer-settings-button',
        BANNER: 'cookie-consent-banner',
        PREFERENCES: 'cookie-consent-preferences',
        ACCEPT_ALL_BUTTON: 'cookie-consent-accept-all',
        REJECT_ALL_BUTTON: 'cookie-consent-reject-all',
        MANAGE_PREFERENCES_BUTTON: 'cookie-consent-manage-preferences',
        BACK_BUTTON: 'cookie-consent-back',
        CLOSE_BUTTON: 'cookie-consent-close',
        POLICY_LINK: 'cookie-consent-policy-link',
        POLICY_DOCUMENT: 'cookie-consent-policy-document',
        CATEGORY_TOGGLE: 'cookie-consent-category-toggle',
        EXTERNAL_MEDIA: {
            ENABLE_BUTTON: 'cookie-consent-enable-external-media',
            PLACEHOLDER: 'cookie-consent-external-media-placeholder',
        },
    },
    GET_IN_TOUCH: {
        PAGE: 'get-in-touch-page',
        HEADING: 'get-in-touch-heading',
        FORM: 'get-in-touch-form',
        FIRST_NAME_INPUT: 'get-in-touch-first-name-input',
        FIRST_NAME_ERROR: 'get-in-touch-first-name-error',
        LAST_NAME_INPUT: 'get-in-touch-last-name-input',
        LAST_NAME_ERROR: 'get-in-touch-last-name-error',
        EMAIL_INPUT: 'get-in-touch-email-input',
        EMAIL_ERROR: 'get-in-touch-email-error',
        TOPIC_SELECT: 'get-in-touch-topic-select',
        TOPIC_ERROR: 'get-in-touch-topic-error',
        MESSAGE_INPUT: 'get-in-touch-message-input',
        MESSAGE_ERROR: 'get-in-touch-message-input-error',
        SUBMIT_BTN: 'get-in-touch-submit-btn',
        SUBMIT_ERROR: 'get-in-touch-submit-error',
        SUCCESS: 'get-in-touch-success',
        SUCCESS_RESET_BTN: 'get-in-touch-success-reset-btn',
    },
    CONTACT_SUPPORT: {
        DIALOG: 'contact-support-dialog',
        MESSAGE_INPUT: 'contact-support-message-input',
        SEND_BTN: 'contact-support-send-btn',
    },
    SMS_MARKETING: {
        PHONE_COUNTRY: 'contact-phone-country',
        PHONE_COUNTRY_MENU: 'contact-phone-country-menu',
        PHONE_COUNTRY_OPTION: 'contact-phone-country-option',
        CALL_BUTTON: 'contact-verification-call',
        SIGNUP: 'sms-marketing-signup',
        EMAIL_INPUT: 'sms-marketing-email-input',
        PHONE_INPUT: 'sms-marketing-phone-input',
        CONSENT_CHECKBOX: 'sms-marketing-consent-checkbox',
        SUBMIT_BUTTON: 'sms-marketing-submit-button',
        CODE_INPUT: 'sms-marketing-code-input',
        VERIFY_DIALOG: 'sms-marketing-verify-dialog',
        VERIFY_DIALOG_DISMISS: 'sms-marketing-verify-dialog-dismiss',
        VERIFY_BUTTON: 'sms-marketing-verify-button',
        RESEND_BUTTON: 'sms-marketing-resend-button',
        RESEND_COUNTDOWN: 'sms-marketing-resend-countdown',
        CODE_WAITING: 'sms-marketing-code-waiting',
        ENTER_CODE_BUTTON: 'sms-marketing-enter-code-button',
        CHANGE_NUMBER_BUTTON: 'sms-marketing-change-number-button',
        ERROR_MESSAGE: 'sms-marketing-error-message',
        RESULT_MESSAGE: 'sms-marketing-result-message',
        PRIVACY_POLICY_LINK: 'sms-marketing-privacy-policy-link',
        TERMS_OF_USE_LINK: 'sms-marketing-terms-of-use-link',
        /** Retired main page modal; kept so specs can assert it never comes back. */
        MAIN_PAGE_MODAL: 'sms-marketing-main-page-modal',
        ONBOARDING_FIELDS: 'sms-marketing-onboarding-fields',
        ONBOARDING_SUBSCRIBED: 'sms-marketing-onboarding-subscribed',
        ONBOARDING_SKIP_BUTTON: 'sms-marketing-onboarding-skip-button',
        PROFILE_PHONE: 'sms-marketing-profile-phone',
        PROFILE_CONSENT: 'sms-marketing-profile-consent',
        PROFILE_CHANGE_NUMBER_BUTTON: 'sms-marketing-profile-change-number-button',
        PROFILE_CANCEL_CHANGE_BUTTON: 'sms-marketing-profile-cancel-change-button',
        PROFILE_LOADING: 'sms-marketing-profile-loading',
        SETTINGS_RETRY_BUTTON: 'sms-marketing-settings-retry-button',
    },
    SDS: {
        SDS_TAB: 'sds-tab',
        SDS_AVATAR: 'sds-avatar',
        SDS_IMAGE: 'sds-image',
        SDS_USER_BADGE: 'sds-user-badge',
        SDS_BUTTON: 'sds-button',
        SDS_CHECKBOX: 'sds-checkbox',
        SDS_TABLE: 'sds-table',
        SDS_TABLE_ROW: 'sds-table-row',
        SDS_TABLE_CELL: 'sds-table-cell',
        SDS_TABLE_ROW_CHECKBOX: 'sds-table-row-checkbox',
        SDS_RADIO: 'sds-radio',
        SDS_LINK: 'sds-link',
        SDS_SKELETON: 'sds-skeleton',
        SDS_SWITCH: 'sds-switch',
        SDS_TOGGLE_BUTTON: 'sds-toggle-button',
        SDS_DIALOG: 'sds-dialog',
        INPUT_ERROR: 'sds-input-error',
        SDS_PAGINATION: 'sds-pagination',
        SDS_PAGINATION_TOTAL: 'sds-pagination-total',
        SDS_PAGINATION_PREVIOUS: 'sds-pagination-previous',
        SDS_PAGINATION_NEXT: 'sds-pagination-next',
        SDS_PAGINATION_PAGE: 'sds-pagination-page',
        SDS_PAGINATION_PAGE_SIZE: 'sds-pagination-page-size',
        SDS_PAGINATION_PAGE_SIZE_MENU: 'sds-pagination-page-size-menu',
    },
    TEXT_INPUT: {
        FORM_SUBMIT_BTN: 'form-submit-btn',
        SHOW_PASSWORD: 'show-pwd',
        EMAIL_ERROR: 'email-error',
        PASSWORD_ERROR: 'password-error',
        CONFIRM_PASSWORD_ERROR: 'confirmPassword-error',
    },
    MODALS: {
        IMAGE_UPLOAD: {
            AVATAR: 'image-upload-avatar',
            UPLOAD_BTN: 'image-upload-btn',
            EDIT_BTN: 'image-edit-btn',
            CLOSE_BTN: 'image-close-btn',
            SAVE_BTN: 'image-save-btn',
            CANCEL_BTN: 'image-cancel-btn',
        },
        CONFIRMATION: {
            CONTAINER: 'confirmation-modal',
            CONFIRM_BTN: 'modal-confirm-btn',
            CANCEL_BTN: 'modal-cancel-btn',
            SAVE_CHANGES_BTN: 'modal-save-changes-btn',
        },
        /** In-app prompt shown when router navigation would discard unsaved form edits. */
        UNSAVED_CHANGES: {
            CONTAINER: 'unsaved-changes-dialog',
            DISCARD_BTN: 'unsaved-changes-discard-btn',
            KEEP_EDITING_BTN: 'unsaved-changes-keep-editing-btn',
        },
    },
    HOME: {
        LOGIN_BTN: 'login-btn',
        SIGNUP_BTN: 'signup-btn',
        DASHBOARD_BTN: 'dashboard-btn',
        PROFILE_MENU: 'home-profile-menu',
        LOGOUT_BTN: 'home-logout-btn',
        REVIEW_CAROUSEL: 'home-review-carousel',
    },
    BILLING: {
        PACKAGE_SECTION: 'billing-package-section',
        PACKAGE_TITLE: 'billing-package-title',
        PACKAGE_ENTITLEMENT: 'billing-package-entitlement',
        PACKAGE_LOADING_STATE: 'billing-package-loading-state',
        PACKAGE_ERROR_STATE: 'billing-package-error-state',
        PACKAGE_EMPTY_STATE: 'billing-package-empty-state',
        PAYMENT_SUMMARY: 'billing-payment-summary',
        SUMMARY_PLAN_KIND: 'billing-summary-plan-kind',
        SUMMARY_PROGRESS: 'billing-summary-progress',
        SUMMARY_DISCOUNT: 'billing-summary-discount',
        SUMMARY_AMOUNT_PAID: 'billing-summary-amount-paid',
        SUMMARY_PAYMENT_DATE: 'billing-summary-payment-date',
        SUMMARY_REMAINING_BALANCE: 'billing-summary-remaining-balance',
        SUMMARY_NEXT_PAYMENT: 'billing-summary-next-payment',
        VIEW_RECEIPT: 'billing-view-receipt',
        STRIPE_NOTICE: 'billing-stripe-notice',
        PACKAGE_ACTIONS: 'billing-package-actions',
        REFUND_POLICY_NOTE: 'billing-refund-policy-note',
        REFUND_POLICY_NOTE_LINK: 'billing-refund-policy-note-link',
        VIEW_PAYMENT_PLAN: 'billing-view-payment-plan',
        PAY_REMAINING_BALANCE: 'billing-pay-remaining-balance',
        REQUEST_REFUND: 'billing-request-refund',
        REFUND: {
            DIALOG: 'billing-refund-dialog',
            PACKAGE_SUMMARY: 'billing-refund-package-summary',
            POLICY_NOTE: 'billing-refund-dialog-policy-note',
            LOADING_STATE: 'billing-refund-loading-state',
            ERROR_STATE: 'billing-refund-error-state',
            WINDOW_FACT: 'billing-refund-window-fact',
            COMPLETION_FACT: 'billing-refund-completion-fact',
            COMPLETION_PILL: 'billing-refund-completion-pill',
            AMOUNT_FACT: 'billing-refund-amount-fact',
            REFUND_TO_FACT: 'billing-refund-to-fact',
            NOTICE: 'billing-refund-notice',
            POLICY_LINK: 'billing-refund-policy-link',
            REASON_SELECT: 'billing-refund-reason-select',
            REASON_DETAIL: 'billing-refund-reason-detail',
            REASON_COUNTER: 'billing-refund-reason-counter',
            CONFIRM: 'billing-refund-confirm',
            CONTACT_SUPPORT: 'billing-refund-contact-support',
            DETAILS_DIALOG: 'billing-refund-details-dialog',
            DETAILS_REASON: 'billing-refund-details-reason',
            DETAILS_REFUNDED_ON: 'billing-refund-details-refunded-on',
            VIEW_REFUND_DETAILS: 'billing-view-refund-details',
            VIEW_ORIGINAL_RECEIPT: 'billing-view-original-receipt',
            PENDING_STATE: 'billing-refund-pending-state',
            REFUNDED_AMOUNT_PAID: 'billing-refunded-amount-paid',
            REFUNDED_AMOUNT_REFUNDED: 'billing-refunded-amount-refunded',
        },
        DISPUTE_NOTICE: 'billing-dispute-notice',
        DISPUTE_CONTACT_SUPPORT: 'billing-dispute-contact-support',
        PAYMENT_METHODS_SECTION: 'billing-payment-methods-section',
        PAYMENT_METHODS_LOADING_STATE: 'billing-payment-methods-loading-state',
        PAYMENT_METHODS_ERROR_STATE: 'billing-payment-methods-error-state',
        PAYMENT_METHODS_EMPTY_STATE: 'billing-payment-methods-empty-state',
        PAYMENT_METHOD_ROW: 'billing-payment-method-row',
        PAYMENT_METHOD_CARDHOLDER: 'billing-payment-method-cardholder',
        CHANGE_PAYMENT_METHOD: 'billing-change-payment-method',
        CONTINUE_TO_STRIPE_DIALOG: 'billing-continue-to-stripe-dialog',
        CONTINUE_TO_STRIPE_CONFIRM: 'billing-continue-to-stripe-confirm',
        HISTORY_SECTION: 'billing-history-section',
        HISTORY_TABLE: 'billing-history-table',
        HISTORY_LOADING_STATE: 'billing-history-loading-state',
        HISTORY_ERROR_STATE: 'billing-history-error-state',
        HISTORY_EMPTY_STATE: 'billing-history-empty-state',
        HISTORY_STALE_PAGE_STATE: 'billing-history-stale-page-state',
        HISTORY_STALE_WARNING: 'billing-history-stale-warning',
        HISTORY_RETRY: 'billing-history-retry',
        HISTORY_ROW_ACTION: 'billing-history-row-action',
        HISTORY_PAGINATION: 'billing-history-pagination',
        HISTORY_CELL_DATE: 'billing-history-cell-date',
        HISTORY_CELL_DESCRIPTION: 'billing-history-cell-description',
        HISTORY_CELL_STATUS: 'billing-history-cell-status',
        HISTORY_CELL_AMOUNT: 'billing-history-cell-amount',
    },
    DASHBOARD: {
        GET_STARTED: {
            TITLE: 'get-started-title',
            CONTAINER: 'get-started-section',
            CARD: 'karma-card',
            CARD_TITLE: 'karma-card-title',
        },
        FIRST_LESSON_CARD: 'dashboard-first-lesson-card',
        FIRST_LESSON_CTA: 'dashboard-first-lesson-cta',
        VERIFY_EMAIL_NOTICE: 'dashboard-verify-email-notice',
        SCENARIO_SECTION: 'dashboard-scenario-section',
        SCENARIO_CARD: 'dashboard-scenario-card',
        WEEKLY_CALENDAR: 'dashboard-weekly-calendar',
        WEEKLY_CALENDAR_DAYS: 'dashboard-weekly-calendar-days',
        WEEKLY_CALENDAR_MORE_EVENTS: 'dashboard-weekly-calendar-more-events',
        UPCOMING_LIVE_EVENTS_SECTION: 'dashboard-upcoming-live-events-section',
        LOGO_IMAGE: 'dashboard-logo-image',
        MBA_PROMO_CARD: 'dashboard-mba-promo-card',
        MBA_PROMO_CARD_CTA: 'dashboard-mba-promo-card-cta',
        PARTNER_WORKSHOPS_SECTION: 'dashboard-partner-workshops-section',
        WELCOME_TITLE: 'welcome-title',
        WELCOME_MESSAGE: 'dashboard-welcome-message',
        WELCOME_BACK_MESSAGE: 'dashboard-welcome-back-message',
        PROFILE_BTN: 'dashboard-profile-btn',
        TOOLS_TEMPLATES_CAROUSEL: 'tools-templates-carousel',
        TOOLS_TEMPLATES_CARD: 'dash-tools-templates-card',
        DEALS_DISCOUNTS_CAROUSEL: 'deals-discounts-carousel',
        /**
         * One carousel slide (two deals), suffixed `-<groupIndex>`: Swiper loop mode reorders slides in the DOM, so the
         * index (stripped from production builds with every test id) is the data order.
         */
        DEALS_DISCOUNTS_GROUP: 'dash-deals-discounts-group',
        DEALS_DISCOUNTS_CARD: {
            CONTAINER: 'dash-deals-discounts-card',
            TITLE: 'dash-deal-title',
            VALUE: 'dash-deal-value',
            BUTTON: 'dash-deal-btn',
        },
        MENTOR: {
            STARTED_COURSE_CARD: 'mentor-started-course-card',
            STARTED_COURSE_COUNT: 'recent-started-count',
            COMPLETED_COURSE_CARD: 'mentor-completed-course-card',
            FINISHED_COURSE_COUNT: 'recent-finished-count',
            ATTENDED_WORKSHOP_CARD: 'mentor-attended-workshop-card',
            ATTENDED_WORKSHOP_COUNT: 'recent-attended-count',
        },
        RESUME_PROGRESS: {
            SECTION: 'dashboard-resume-progress-section',
            LOAD_ERROR: 'dashboard-resume-progress-load-error',
            RETRY_BTN: 'dashboard-resume-progress-retry-btn',
        },
    },
    PRICING: {
        CHECKOUT_RETURN: 'pricing-checkout-return',
        RETURN_HEADING: 'pricing-return-heading',
        RETURN_BODY: 'pricing-return-body',
        RETURN_REFERENCE: 'pricing-return-reference',
        RETURN_ACTION: 'pricing-return-action',
        DISCOUNT_CODE: 'pricing-discount-code',
        APPLY_DISCOUNT: 'pricing-apply-discount',
        OFFER_NOTICE: 'pricing-offer-notice',
        OFFER_SWITCH_ACCOUNT: 'pricing-offer-switch-account',
        PAGE: 'pricing-page',
        TUITION_PANEL: 'pricing-tuition-panel',
        TUITION_SUMMARY: 'pricing-tuition-summary',
        INFORMATION_PANEL: 'pricing-information-panel',
        SELECTION_CARD: 'pricing-selection-card',
        BACK_BUTTON: 'pricing-back-button',
        DISCOUNT_BADGE: 'pricing-discount-badge',
        PLAN_INSTALLMENT: 'pricing-plan-installment',
        PLAN_ONE_TIME: 'pricing-plan-one-time',
        CONTINUE_BUTTON: 'pricing-continue-button',
        COURSE_TITLE: 'pricing-course-title',
        DUE_TODAY: 'pricing-due-today',
        DUE_TODAY_LABEL: 'pricing-due-today-label',
        TOTAL: 'pricing-total',
        TOTAL_LABEL: 'pricing-total-label',
        PAYMENT_NOTE: 'pricing-payment-note',
        ORIGINAL_PRICE: 'pricing-original-price',
        SELECTION_TOGGLE: 'pricing-selection-toggle',
        MOBILE_BACK_ROW: 'pricing-mobile-back-row',
        PAYMENT_PANEL: 'pricing-payment-panel',
        EDIT_TUITION_BUTTON: 'pricing-edit-tuition-button',
        PAY_BUTTON: 'pricing-pay-button',
        CONTINUE_FREE_LINK: 'pricing-continue-free-link',
        CARD_NUMBER_INPUT: 'pricing-card-number-input',
        CARD_EXPIRY_INPUT: 'pricing-card-expiry-input',
        CARD_CVC_INPUT: 'pricing-card-cvc-input',
        CARD_NAME_INPUT: 'pricing-card-name-input',
    },
    PREMIUM_CHECKOUT: {
        INFORMATION_BLOCK: 'premium-checkout-information-block',
        INFORMATION_NEXT: 'premium-checkout-information-next',
        INFORMATION_SUMMARY: 'premium-checkout-information-summary',
        INFORMATION_EDIT: 'premium-checkout-information-edit',
        FIRST_NAME: 'premium-checkout-first-name',
        LAST_NAME: 'premium-checkout-last-name',
        EMAIL: 'premium-checkout-email',
        PHONE_SUMMARY: 'premium-checkout-phone-summary',
        TERMS: 'premium-checkout-terms',
        EXISTING_ACCOUNT: 'premium-checkout-existing-account',
        EXISTING_ACCOUNT_LOGIN: 'premium-checkout-existing-account-login',
        OFFER_LOGIN_NOTE: 'premium-checkout-offer-login-note',
        ERROR: 'premium-checkout-error',
    },
    MENTOR_COACHING_DASHBOARD: {
        PAGE: 'mentor-coaching-dashboard-page',
        TITLE: 'mentor-coaching-dashboard-title',
        EMPTY_STATE: 'mentor-coaching-dashboard-empty-state',
        SESSIONS_COUNT: 'mentor-coaching-dashboard-sessions-count',
        SESSIONS_COUNT_VALUE: 'mentor-coaching-dashboard-sessions-count-value',
        SESSIONS_ERROR: 'mentor-coaching-dashboard-sessions-error',
        SESSIONS_RETRY_BTN: 'mentor-coaching-dashboard-sessions-retry-btn',
        COMPLETE_SETUP_BTN: 'mentor-coaching-dashboard-complete-setup-btn',
        SESSION_REQUEST_INBOX: 'mentor-coaching-session-request-inbox',
        SESSION_REQUEST_EMPTY: 'mentor-coaching-session-request-empty',
        SESSION_REQUEST_LOADING: 'mentor-coaching-session-request-loading',
        SESSION_REQUEST_ERROR: 'mentor-coaching-session-request-error',
        SESSION_REQUEST_CARD: 'mentor-coaching-session-request-card',
        SESSION_REQUEST_ACCEPT_BTN: 'mentor-coaching-session-request-accept-btn',
        SESSION_REQUEST_DECLINE_BTN: 'mentor-coaching-session-request-decline-btn',
    },
    MENTOR_DASHBOARD: {
        CALENDAR_TODAY_BTN: 'mentor-dashboard-calendar-today-btn',
        SESSIONS_COUNT: 'mentor-dashboard-sessions-count',
        WORKSHOPS_TITLE: 'mentor-dashboard-workshops-title',
        WORKSHOPS_LIST: 'mentor-dashboard-workshops-list',
        WORKSHOPS_EMPTY: 'mentor-dashboard-workshops-empty',
        WORKSHOP_CARD: {
            CONTAINER: 'mentor-dashboard-workshop-card',
            TIME: 'mentor-dashboard-workshop-time',
            TITLE: 'mentor-dashboard-workshop-title',
            CHIP: 'mentor-dashboard-workshop-chip',
        },
        UPCOMING_EVENTS: {
            SECTION: 'mentor-dashboard-upcoming-events-section',
            TITLE: 'mentor-dashboard-upcoming-events-title',
            EMPTY: 'mentor-dashboard-upcoming-events-empty',
            EMPTY_MESSAGE: 'mentor-dashboard-upcoming-events-empty-message',
        },
    },
    MY_MBA: {
        EMPTY_CTA: 'my-mba-empty-cta',
        INACTIVE_ACCESS_CTA: 'my-mba-inactive-access-cta',
        PAGE: 'my-mba-page',
        ACCESS_CARD: 'my-mba-access-card',
        TOP_FOUNDER_CARD: 'my-mba-top-founder-card',
        TOP_FOUNDER_NUMBER: 'my-mba-top-founder-number',
        CERTIFICATE_CARD: 'my-mba-certificate-card',
        DOWNLOAD_BUTTON: 'my-mba-download-button',
        VERIFICATION_LINK: 'my-mba-verification-link',
        SHARE_SECTION: 'my-mba-share-section',
        HISTORY_SECTION: 'my-mba-history-section',
        HISTORY_CARD: 'my-mba-history-card',
        STATUS_BADGE: 'my-mba-status-badge',
    },
    MBA_UPSELL: {
        CARD: 'mba-contextual-card',
        CTA: 'mba-contextual-card-cta',
    },
    COURSE_PROMPT: {
        BACK_TO_LESSONS: 'course-back-to-lessons',
        MEDIA: 'course-preview-media',
        ROOT: 'course-access-prompt',
        HEADING: 'course-access-prompt-heading',
        CTA: 'course-access-prompt-cta',
        REPLAY: 'course-access-prompt-replay',
        DISMISS: 'course-access-prompt-dismiss',
        OFFER_CODE: 'course-access-prompt-offer-code',
    },
    LOCKED_CONTENT_MODAL: {
        ROOT: 'locked-content-modal',
        TITLE: 'locked-content-modal-title',
        DESCRIPTION: 'locked-content-modal-description',
        BENEFITS: 'locked-content-modal-benefits',
        UPGRADE_CTA: 'locked-content-modal-upgrade-cta',
        CONTINUE_FREE: 'locked-content-modal-continue-free',
        REPLAY_PREVIEW: 'locked-content-modal-replay-preview',
        CLOSE: 'locked-content-modal-close',
    },
    CERTIFICATE_VERIFICATION: {
        HERO: 'certificate-verification-hero',
        VALID_STATE: 'certificate-verification-valid-state',
        INVALID_STATE: 'certificate-verification-invalid-state',
        DETAILS: 'certificate-verification-details',
        SHARE_TRIGGER: 'certificate-verification-share-trigger',
        SHARE_MENU: 'certificate-verification-share-menu',
        SHARE_LINKEDIN: 'certificate-verification-share-linkedin',
        SHARE_FACEBOOK: 'certificate-verification-share-facebook',
        SHARE_TWITTER: 'certificate-verification-share-twitter',
        SHARE_WHATSAPP: 'certificate-verification-share-whatsapp',
        SHARE_EMAIL: 'certificate-verification-share-email',
    },
    PROFILE: {
        TAGLINE: 'profile-tagline',
        USER_AVATAR: 'user-avatar',
        IMAGE_UPLOAD_BTN: 'profile-upload-btn',
        IMAGE_REMOVE_BTN: 'profile-remove-btn',
        FIRST_NAME: 'profile-firstname',
        FIRST_NAME_ERROR: 'profile-firstname-error',
        LAST_NAME: 'profile-lastname',
        LAST_NAME_ERROR: 'profile-lastname-error',
        COMPANY: 'profile-company',
        COMPANY_ERROR: 'profile-company-error',
        POSITION: 'profile-position',
        POSITION_ERROR: 'profile-position-error',
        ABOUT: 'profile-about',
        ABOUT_ERROR: 'profile-about-error',
        EMAIL: 'profile-email',
        EMAIL_ERROR: 'profile-email-error',
        LINKEDIN: 'profile-linkedin',
        LINKEDIN_ERROR: 'profile-linkedin-error',
        X: 'profile-x',
        X_ERROR: 'profile-x-error',
        INSTAGRAM: 'profile-instagram',
        INSTAGRAM_ERROR: 'profile-instagram-error',
        TIKTOK: 'profile-tiktok',
        TIKTOK_ERROR: 'profile-tiktok-error',
        SAVE_CHANGES_BTN: 'profile-save-btn',
        LOGOUT_BTN: 'logout-btn',
        DELETE_ACCOUNT_BTN: 'delete-account-btn',
        GOOGLE_ACCOUNT_CONNECTED: 'profile-google-account-connected',
        GOOGLE_ACCOUNT_EMAIL: 'profile-google-account-email',
        CONNECT_GOOGLE_BTN: 'profile-connect-google-btn',
        DISCONNECT_GOOGLE_BTN: 'profile-disconnect-google-btn',
        CONFIRM_DISCONNECT_BTN: 'profile-confirm-disconnect-btn',
        USER_PROFILE_MENU: 'user-profile-menu',
        CONNECTED_ACCOUNTS_COUNT: 'profile-connected-accounts-count',
        CANNOT_DISCONNECT_WARNING: 'profile-cannot-disconnect-warning',
        MANAGE_ACCOUNT: 'manage-account-btn',
    },
    COURSES: {
        ERROR: {
            LOADING_TITLE: 'course-error-loading-title',
        },
        CARD: {
            CONTAINER: 'course-card',
            TITLE: 'course-card-title',
            DESCRIPTION: 'course-card-description',
            CATEGORY: 'course-card-category',
        },
        PREVIEW_MODAL: {
            TITLE: 'course-preview-modal-title',
            DESCRIPTION: 'course-preview-modal-description',
            GO_TO_COURSE: 'course-preview-go-to-course',
            BOOKMARK: 'course-preview-bookmark',
            MOBILE_ACTIONS_MENU_TRIGGER: 'course-preview-mobile-actions-menu-trigger',
        },
    },
    LIVE_EVENTS: {
        TITLE: 'event-title',
        CARD: {
            CONTAINER: 'live-event-card',
            TITLE: 'event-card-title',
            ATTEND_BTN: 'event-attend-btn',
            DATE: 'event-card-date',
            CANCELLED_BADGE: 'live-event-card-cancelled-badge',
        },
        CONTENT_INFO: {
            CONTAINER: 'live-event-info-content',
            WEBINAR_STATUS: 'live-event-webinar-status',
            START_DATETIME: 'live-event-start-datetime',
            JOIN_ZOOM: 'live-event-join-zoom',
            OPEN_IN_BROWSER: 'live-event-open-in-browser',
            RECORDING_UNAVAILABLE: 'live-event-recording-unavailable',
            CANCELLED_BANNER: 'live-event-cancelled-banner',
            CANCELLED_MAIN: 'live-event-cancelled-main',
        },
        MINE_FILTER_TOGGLE: 'live-events-mine-filter-toggle',
        CARD_LIST: 'live-events-card-list',
        FREE_SECTION: 'free-live-events-section',
        FREE_SECTION_ERROR: 'free-live-events-section-error',
        FREE_SECTION_RETRY: 'free-live-events-section-retry',
        MONTHLY_SECTION: 'monthly-free-workshop-section',
        MONTHLY_SECTION_ERROR: 'monthly-free-workshop-section-error',
        MONTHLY_SECTION_RETRY: 'monthly-free-workshop-section-retry',
    },
    CALENDAR: {
        PAGE_TITLE: 'calendar-page-title',
        CONTAINER: 'calendar-page-container',
        LOADING: 'calendar-page-loading',
        EMPTY: 'calendar-page-empty',
        ERROR: 'calendar-page-error',
        RETRY: 'calendar-page-retry',
        MONTH_TRIGGER: 'calendar-page-month-trigger',
        DATE_TRIGGER: 'calendar-page-date-trigger',
        TODAY: 'calendar-page-today',
    },
    ENTRY_FEATURE: {
        SORT_FILTER: 'entry-feature-sort-filter',
        SORT_TRIGGER: 'entry-feature-sort-trigger',
        SORT_DROPDOWN: 'entry-feature-sort-dropdown',
        SORT_OPTION_PREFIX: 'entry-feature-sort-option',
    },
    DEALS_AND_DISCOUNTS: {
        CONTAINER: 'deals-discounts-card',
        TITLE: 'discount-title',
        CARD_DESCRIPTION: 'discount-card-description',
        VALUE: 'discount-value',
        CATEGORY_PILL: 'discount-category-pill',
        GET_IT_BTN: 'get-it-btn',
        GRAB_THAT_DEAL_BTN: 'grab-that-deal-btn',
        DETAIL_CATEGORY: 'discount-detail-category',
        DETAIL_DESCRIPTION: 'discount-detail-description',
        DETAIL_HOW_TO_USE: 'discount-detail-how-to-use',
        DETAIL_TERMS: 'discount-detail-terms',
        DETAIL_LOGO: 'discount-detail-logo',
        NOT_FOUND: 'discount-detail-not-found',
    },
    ONE_ON_ONE_COACHING: {
        PAGE_TITLE: 'one-on-one-coaching-page-title',
        CARD_LIST: 'one-on-one-coaching-card-list',
        EMPTY_STATE: 'one-on-one-coaching-empty-state',
        CARD: 'one-on-one-coaching-card',
        CARD_NAME: 'one-on-one-coaching-card-name',
        TOP_EXPERT_BADGE: 'one-on-one-coaching-top-expert-badge',
    },
    MENTOR_PROFILE: {
        MESSAGE_BUTTON: 'mentor-profile-message-button',
        ASSOCIATED_COURSES: 'mentor-profile-associated-courses',
        ASSOCIATED_LIVE_EVENTS: 'mentor-profile-associated-live-events',
        ASSOCIATED_EMAIL_TEMPLATES: 'mentor-profile-associated-email-templates',
        ASSOCIATED_DOCUMENT_TEMPLATES: 'mentor-profile-associated-document-templates',
        MENTORS_ROW: 'mentor-profile-mentors-row',
        SECONDARY_FACEPILE: 'mentor-profile-secondary-facepile',
    },
    MENTOR_FILTERS: {
        OPEN_BUTTON: 'mentor-filters-open-button',
        TOP_EXPERTS_SWITCH: 'mentor-filters-top-experts-switch',
        AVAILABLE_ASAP_SWITCH: 'mentor-filters-available-asap-switch',
        FROM_DATE: 'mentor-filters-from-date',
        TO_DATE: 'mentor-filters-to-date',
        PART_OF_DAY_MORNING: 'mentor-filters-part-of-day-morning',
        PART_OF_DAY_NOON: 'mentor-filters-part-of-day-noon',
        PART_OF_DAY_EVENING: 'mentor-filters-part-of-day-evening',
        DURATION_15: 'mentor-filters-duration-15',
        DURATION_30: 'mentor-filters-duration-30',
        DURATION_45: 'mentor-filters-duration-45',
        DURATION_60: 'mentor-filters-duration-60',
        DURATION_120: 'mentor-filters-duration-120',
        DURATION_180: 'mentor-filters-duration-180',
        CLEAR_BUTTON: 'mentor-filters-clear-button',
        SEARCH_BUTTON: 'mentor-filters-search-button',
    },
    TOOLS_AND_TEMPLATES: {
        TITLE: 'template-title',
        DESCRIPTION: 'template-description',
        MENTOR_NAME: 'template-mentor-name',
        TYPE_TAB_EMAIL: 'template-type-tab-email',
        TYPE_TAB_DOCUMENT: 'template-type-tab-document',
        CATEGORY_BUTTON: 'category-button',
        CATEGORY_CARD: 'category-card',
        ADD_IMAGE_BTN: 'add-image-btn',
        PAGE_TITLE: 'page-title',
        DOCUMENT: {
            DOWNLOAD_BTN: 'document-template-download-btn',
        },
        EMAIL: {
            BODY: 'email-template-body',
            COPY_BODY_BTN: 'copy-body-btn',
            COPY_SUBJECT_BTN: 'copy-subject-btn',
            /** Tooltip popup for subject copy (idle or success text). */
            COPY_SUBJECT_TOOLTIP: 'email-template-copy-subject-tooltip',
            SUBJECT: 'email-template-subject',
            TAB_EMAIL: 'email-template-tab-email',
            TAB_LINKEDIN: 'email-template-tab-linkedin',
        },
        CARD: {
            CONTAINER: 'tools-templates-card',
            TITLE: 'tools-card-title',
            DESCRIPTION: 'tools-card-description',
            ACCESS_BTN: 'tools-card-btn',
            DOWNLOAD_BTN: 'tools-card-download-btn',
        },
    },
    COURSE_PAGE: {
        BACK_TO_DASHBOARD: 'back-to-dashboard',
    },
    LOGIN: {
        GOOGLE_AUTH_BTN: 'google-auth-btn',
        LINKEDIN_AUTH_BTN: 'linkedin-auth-btn',
        EMAIL_AND_PWD_BUTTON: 'email-pwd-button',
        FORGOT_PASSWORD: 'forgot-pwd',
        FORGOT_PASSWORD_EMAIL_FIELD: 'forgot-password-email',
        FORGOT_PASSWORD_EMAIL_ERROR: 'forgot-password-email-error',
        BACK_TO_LOGIN_LINK: 'auth-back-to-login-link',
        SUBMIT_BTN: 'login-submit',
        EMAIL_FIELD: 'login-email',
        EMAIL_ERROR: 'login-email-error',
        PASSWORD_FIELD: 'login-password',
        PASSWORD_ERROR: 'login-password-error',
        REMEMBER_ME: 'login-remember-me',
        FORGOT_PASSWORD_TITLE: 'forgot-password-title',
        RECEIVED_EMAIL_SUBTITLE: 'received-email-subtitle',
        SIGNUP_LINK: 'signup-link',
        OAUTH_ERROR_MESSAGE: 'oauth-error-message',
        TRY_AGAIN_BTN: 'try-again-btn',
        MFA_CHALLENGE: 'login-mfa-challenge',
        MFA_FACTOR: 'login-mfa-factor',
        MFA_CODE: 'login-mfa-code',
        MFA_CONFIRM: 'login-mfa-confirm',
        MFA_CANCEL: 'login-mfa-cancel',
        MFA_EMAIL_SEND: 'login-mfa-email-send',
        MFA_SMS_SEND: 'login-mfa-sms-send',
        MFA_PASSKEY: 'login-mfa-passkey',
        MFA_ERROR: 'login-mfa-error',
        MFA_RESTART: 'login-mfa-restart',
        MARKETING_HERO: 'auth-marketing-hero',
        AUTH_PANEL: 'auth-layout-panel',
    },
    RESET_PASSWORD: {
        PASSWORD_INPUT: 'password-input',
        PASSWORD_ERROR: 'reset-password-password-error',
        CONFIRM_PASSWORD_INPUT: 'confirmPassword-input',
        CONFIRM_PASSWORD_ERROR: 'reset-password-confirm-password-error',
        INVALID_LINK_TITLE: 'reset-password-invalid-link-title',
        INVALID_LINK_MESSAGE: 'reset-password-invalid-link-message',
        REQUEST_NEW_LINK_BTN: 'reset-password-request-new-link-btn',
    },
    VERIFY_EMAIL: {
        TITLE: 'verify-email-title',
        HINT: 'verify-email-hint',
        GO_TO_ONBOARDING_BTN: 'verify-email-go-to-onboarding-btn',
        ERROR_TITLE: 'verify-email-error-title',
        ERROR_HINT: 'verify-email-error-hint',
        RETRY_BTN: 'verify-email-retry-btn',
        REQUEST_NEW_LINK_BTN: 'verify-email-request-new-link-btn',
    },
    SIGNUP: {
        LOGIN_LINK: 'signup-login-link',
        OAUTH_ERROR_MESSAGE: 'signup-oauth-error-message',
        FIRST_NAME_FIELD: 'signup-first-name',
        LAST_NAME_FIELD: 'signup-last-name',
        EMAIL_FIELD: 'signup-email',
        EMAIL_ERROR: 'signup-email-error',
        PHONE_FIELD: 'signup-phone',
        PHONE_ERROR: 'signup-phone-error',
        PASSWORD_FIELD: 'signup-pwd',
        PASSWORD_ERROR: 'signup-pwd-error',
        CONFIRM_PWD_FIELD: 'signup-confirm-pwd',
        CONFIRM_PWD_ERROR: 'signup-confirm-pwd-error',
        SUBMIT_BTN: 'signup-submit',
        CONFIRM_EMAIL_TITLE: 'signup-confirm-email-title',
        CONFIRM_EMAIL_MSG: 'signup-confirm-email-msg',
        OPEN_EMAIL_PROVIDER_BTN: 'signup-open-email-provider-btn',
        RESEND_VERIFICATION_BTN: 'signup-resend-verification-btn',
        RESEND_COOLDOWN_MESSAGE: 'signup-resend-cooldown-message',
    },
    ONBOARDING: {
        SCREEN: 'onboarding-screen',
        SIGN_OUT_BUTTON: 'onboarding-sign-out-button',
        SCREEN_CONTENT: 'onboarding-screen-content',
        FIELDS_SCROLLER: 'onboarding-fields-scroller',
        SIDEBAR: 'onboarding-sidebar',
        SIDEBAR_TESTIMONIALS: 'onboarding-sidebar-testimonials',
        PICTURE_FILE_INPUT: 'onboarding-picture-file-input',
        CROPPER_IMAGE: 'onboarding-cropper-image',
        CROPPER_ZOOM: 'onboarding-cropper-zoom',
        CROPPER_ROTATE: 'onboarding-cropper-rotate',
        FIRST_NAME: 'firstName-input',
        FIRST_NAME_ERROR: 'firstName-error',
        LAST_NAME: 'lastName-input',
        LAST_NAME_ERROR: 'lastName-error',
        PICTURE_STEP: 'onboarding-picture-step',
        PICTURE_TRIGGER: 'onboarding-picture-trigger',
        COMPANY: 'company-input',
        COMPANY_ERROR: 'company-error',
        POSITION: 'jobTitle-input',
        POSITION_ERROR: 'jobTitle-error',
        TAGLINE: 'tagline-input',
        TAGLINE_ERROR: 'tagline-error',
        LINKEDIN: 'linkedin-input',
        X: 'x-input',
        INSTAGRAM: 'instagram-input',
        TIKTOK: 'tiktok-input',
        STEP_TITLE: 'step-title',
        WELCOME_TITLE: 'onboarding-welcome-title',
        CONTINUE_BTN: 'onboarding-continue-btn',
        FINISH_BTN: 'onboarding-finish-btn',
        SINGLE_CHOICE_BTN: 'single-option-btn',
        MULTI_CHOICE_BTN: 'multi-option-btn',
        BACK_BTN: 'back-btn',
        SAVE_AND_NEXT_BTN: 'save-next-btn',
        COUNTRY_SELECT: 'country-select',
        COUNTRY_SEARCH_INPUT: 'country-search-input',
        /** The chip the country filter shows in place of its trigger once a country is picked. */
        COUNTRY_FILTER_CHIP: 'country-filter-chip',
        COUNTRY_FILTER_CHIP_CLEAR: 'country-filter-chip-clear',
        TIMEZONE_SELECT: 'timezone-select',
        TIMEZONE_SEARCH_INPUT: 'timezone-search-input',
        PRIMARY_CATEGORY_SELECT: 'primaryCategory-select',
        SECONDARY_CATEGORIES_SELECT: 'secondaryCategories-select',
        ABOUT_ME_TEXTAREA: 'aboutMe-textarea',
        ABOUT_ME_ERROR: 'aboutMe-textarea-error',
        COUNTRY_ERROR: 'country-error',
        CURRENT_STAGE_ERROR: 'currentStage-error',
        INDUSTRIES_ERROR: 'industries-error',
        TIME_DEDICATION_ERROR: 'timeDedication-error',
        INTERESTS_ERROR: 'interests-error',
        DESCRIPTION_TEXTAREA: 'description-textarea',
        DESCRIPTION_ERROR: 'description-textarea-error',
        PRIMARY_CATEGORY_ERROR: 'primaryCategory-error',
        LINKEDIN_ERROR: 'linkedin-error',
        X_ERROR: 'x-error',
        INSTAGRAM_ERROR: 'instagram-error',
        TIKTOK_ERROR: 'tiktok-error',
        APPLY_FIELDS_ERROR: 'applyFields-error',
        SKIP_SETUP_BTN: 'skip-setup-btn',
        START_SETUP_BTN: 'start-setup-btn',
        SCHEDULE_TAB: 'schedule-tab',
        SCHEDULE_PRICE_INPUT: 'schedule-price-input',
        SCHEDULE_DISCOUNT_INPUT: 'schedule-discount-input',
        ADD_AVAILABILITY_BTN: 'add-availability-btn',
        ADD_NEW_SCHEDULE_BTN: 'add-schedule-btn',
        SCHEDULE_NAME_INPUT: 'schedule-name-input',
        TIME_FROM: 'time-from',
        TIME_TO: 'time-to',
        DAY_AVAILABILITY: 'day-availability',
        SAVE_AVAILABILITY_BTN: 'save-availability-btn',
        AVAILABILITY_CARD: 'availability-card',
        SCHEDULE_TITLE: 'schedule-title',
    },
    LANDINGPAGE: {
        CERTIFICATE_VALID: 'landing-certificate-valid',
        CERTIFICATE_INVALID: 'landing-certificate-invalid',
        CERTIFICATE_NOT_FOUND: 'landing-certificate-not-found',
        CERTIFICATE_LOADING: 'landing-certificate-loading',
        CERTIFICATE_DETAILS: 'landing-certificate-details',
        CERTIFICATE_REASON: 'landing-certificate-reason',
        CERTIFICATE_SHARE_CONTROLS: 'landing-certificate-share-controls',
        CERTIFICATE_SHARE: (network) => `landing-certificate-share-${network}`,
        APOLLO_ERROR: 'landing-apollo-error',
        APOLLO_RETRY: 'landing-apollo-retry',
        COURSE_NOT_FOUND_BACK_HOME: 'landing-course-not-found-back-home',
        CALCULATOR_INPUT: (name) => `landing-calculator-input-${name}`,
        CALCULATOR_RESULT: (name) => `landing-calculator-result-${name}`,
        CALCULATOR_CHART: (name) => `landing-calculator-chart-${name}`,
        CALCULATOR_CHART_CONTENT: (name) => `landing-calculator-chart-content-${name}`,
        CALCULATOR_PAGE: 'landing-calculator-page',
        CALCULATOR_DIRECTORY: 'landing-calculator-directory',
        CALCULATOR_CARD: (name) => `landing-calculator-card-${name}`,
        CALCULATOR_LOADING: (name) => `landing-calculator-loading-${name}`,
        CALCULATOR_BACK_BUTTON: 'landing-calculator-back-button',
        CALCULATOR_DIRECTORY_CTA: 'landing-calculator-directory-cta',
        CALCULATOR_LINK: (name) => `landing-calculator-link-${name}`,
        CALCULATOR_ACTION: (name) => `landing-calculator-action-${name}`,
        LEGAL_PRIVACY_POLICY_DOCUMENT: 'landing-legal-privacy-policy-document',
        LEGAL_TERMS_OF_USE_DOCUMENT: 'landing-legal-terms-of-use-document',
        COURSE_INSTRUCTOR_ENROLL_BUTTON: 'landing-course-instructor-enroll-button',
        HEADER_NAVIGATION: 'landing-header-navigation',
        HEADER_NAV_ITEM: 'landing-header-nav-item',
        STUDENT_TESTIMONIALS: 'landing-student-testimonials',
        STUDENT_TESTIMONIALS_WRAPPER: 'landing-student-testimonials-wrapper',
        STUDENT_TESTIMONIALS_TOGGLE: 'landing-student-testimonials-toggle',
        STUDENT_TESTIMONIAL_CARD: 'landing-student-testimonial-card',
        STUDENT_TESTIMONIAL_CARD_CONTENT: 'landing-student-testimonial-card-content',
        STUDENT_TESTIMONIAL_CARD_READ_MORE_BTN: 'landing-student-testimonial-card-read-more-btn',
        FAQ_SHOW_MORE: 'landing-faq-show-more',
        FACULTY_HEADING: 'landing-faculty-heading',
        FACULTY_TESTIMONIALS_HEADING: 'landing-faculty-testimonials-heading',
        FACULTY_FAQ_HEADING: 'landing-faculty-faq-heading',
        FACULTY_MONEY_BACK_HEADING: 'landing-faculty-money-back-heading',
        MENTOR_NAME: 'landing-mentor-name',
        MENTOR_LOGO: 'landing-mentor-logo',
        MENTOR_HOVER_VIDEO: 'landing-mentor-hover-video',
        GOODIE_BAG_CARD: 'landing-goodie-bag-card',
        GOODIE_BAG_CARD_LINK: 'landing-goodie-bag-card-link',
        GOODIE_BAG_DOWNLOAD_LINK: 'landing-goodie-bag-download-link',
        GOODIE_BAG_PROTECTED_DOWNLOADS_LIST: 'goodie-bag-protected-downloads-list',
        GOODIE_BAG_PROTECTED_DOWNLOADS_EMPTY: 'goodie-bag-protected-downloads-empty',
        GOODIE_BAG_PROTECTED_DOWNLOAD_CARD: 'goodie-bag-protected-download-card',
        START_YOUR_JOURNEY_SECTION: 'start-your-journey-section',
        ENROLL_NOW_BUTTON: 'landing-enroll-now-button',
        START_FREE_LINK: 'landing-start-free-link',
        PARTNERS_SECTION: 'landing-partners-section',
        LEARN_MORE_BUTTON: 'learn-more-button',
        VIDEO_MODAL: 'landing-video-modal',
        ABOUT_US_LINK: 'landing-about-us-link',
        ABOUT_US_PAGE: 'landing-about-us-page',
        CONTACT_US_LINK: 'landing-contact-us-link',
        ABOUT_US_HERO: 'landing-about-us-hero',
        ABOUT_US_TIMELINE: 'landing-about-us-timeline',
        ABOUT_US_TIMELINE_CARD: 'landing-about-us-timeline-card',
        ABOUT_US_TESTIMONIALS: 'landing-about-us-testimonials',
        ABOUT_US_TESTIMONIALS_WRAPPER: 'landing-about-us-testimonials-wrapper',
        ABOUT_US_TESTIMONIALS_TOGGLE: 'landing-about-us-testimonials-toggle',
        FAQ_TAB_FOUNDER: 'landing-faq-tab-founder',
        FAQ_TAB_MENTOR: 'landing-faq-tab-mentor',
        FAQ_ACCORDION_TRIGGER: 'landing-faq-accordion-trigger',
        SUBSCRIBE_EMAIL: 'subscribe-email',
        MENTOR_SECTION: 'landing-mentor-section',
        MENTOR_CARD_LIST: 'landing-mentor-card-list',
        MENTOR_CARD: 'landing-mentor-card',
        MENTOR_HOVER_MEDIA: 'landing-mentor-hover-media',
        FACULTY_PAGE: 'landing-faculty-page',
        FACULTY_ADVISOR_SECTION: 'landing-faculty-advisor-section',
        FACULTY_ADVISOR_CTA: 'landing-faculty-advisor-cta',
        COURSE_DETAIL_PAGE: 'landing-course-detail-page',
        COURSE_HERO: 'landing-course-hero',
        COURSE_ENROLL_BUTTON: 'landing-course-enroll-button',
        COURSE_CURRICULUM: 'landing-course-curriculum',
        COURSE_CURRICULUM_SHOW_MORE: 'landing-course-curriculum-show-more',
        COURSE_CURRICULUM_EPISODE: 'landing-course-curriculum-episode',
        COURSE_NOT_FOUND: 'landing-course-not-found',
        FOUNDERS_FACULTY_ENROLL_BUTTON: 'landing-founders-faculty-enroll-button',
        FOUNDERS_AUDIENCE_SECTION: 'landing-founders-audience-section',
        FOUNDERS_AUDIENCE_ENROLL_BUTTON: 'landing-founders-audience-enroll-button',
        OUR_MISSION_GET_STARTED_BUTTON: 'landing-our-mission-get-started-button',
        FOUNDERS_CURRICULUM: 'landing-founders-curriculum',
        FOUNDERS_CURRICULUM_ITEM: 'landing-founders-curriculum-item',
        FOUNDERS_CURRICULUM_TRIGGER: 'landing-founders-curriculum-trigger',
        BROWSE_DEALS_BUTTON: 'landing-browse-deals-button',
        START_LEARNING_FREE_BUTTON: 'landing-start-learning-free-button',
        BOOK_ADMISSIONS_CALL_BUTTON: 'landing-book-admissions-call-button',
        BROWSE_TEMPLATES_BUTTON: 'landing-browse-templates-button',
        PRICING_CARD_CTA: (plan) => `landing-pricing-card-cta-${plan}`,
        MONEY_BACK_SECTION: 'landing-money-back-section',
        MONEY_BACK_ENROLL_BUTTON: 'landing-money-back-enroll-button',
        VERTICAL_LOGO_IMAGE: 'landing-vertical-logo-image',
        FACULTY_NAV_LINK: 'landing-faculty-nav-link',
        FOOTER: 'landing-footer',
        FOOTER_LINK: (name) => `landing-footer-link-${name}`,
        FOOTER_ACCORDION_TRIGGER: 'landing-footer-accordion',
        FOUNDERS_CURRICULUM_MEDIA: 'landing-founders-curriculum-media',
        FOUNDERS_CURRICULUM_CLIP: 'landing-founders-curriculum-clip',
    },
    ADMIN: {
        ACQUISITION: {
            PAGE: 'admin-acquisition-page',
            BREAKDOWN: 'admin-acquisition-breakdown',
            TABLE: 'admin-acquisition-table',
            CELL: 'admin-acquisition-cell',
        },
        SIDEBAR: {
            VIDEOS: 'videos-btn',
            MENTORS: 'mentors-btn',
            SCENARIOS: 'scenarios-btn',
            EXTRAS: 'extras-btn',
            EVENTS: 'events-btn',
            PAGE_TITLE: 'page-title',
            PARTNERS: 'partners-btn',
            FEATURE_FLAGS: 'feature-flags-btn',
            CERTIFICATES: 'certificates-btn',
            MBA_OPERATIONS: 'mba-operations-btn',
            PAYMENT_DISPUTES: 'payment-disputes-btn',
            MEETING_REFUND_JOBS: 'meeting-refund-jobs-btn',
        },
        COURSES: {
            ADD_COURSE_BTN: 'add-course-btn',
            TITLE_INPUT: 'title-input',
            TITLE_ERROR: 'admin-courses-title-error',
            DESCRIPTION_INPUT: 'description-input',
            ADD_IMAGE_BTN: 'add-image-btn',
            THUMBNAIL_UPLOAD: 'admin-courses-thumbnail-upload',
            CATEGORY_BTN: 'category-btn',
            MENTOR_BTN: 'mentor-btn',
            STATE_DROPDOWN: 'course-state-dropdown',
            ACCESS_TIER_DROPDOWN: 'course-access-tier-dropdown',
            UPDATE_ACCESS_TIER_BTN: 'course-update-access-tier-btn',
            LANDING_VISIBLE_SWITCH: 'course-landing-visible-switch',
            // Listing-page tabs
            COURSES_TAB: 'admin-courses-tab',
            IN_DRAFT_TAB: 'admin-courses-in-draft-tab',
            ARCHIVED_TAB: 'admin-courses-archived-tab',
            CARD_VIEW_TAB: 'admin-courses-card-view-tab',
            TABLE_VIEW_TAB: 'admin-courses-table-view-tab',
            EDIT_BTN: 'admin-courses-edit-btn',
            BULK_ACTION_BAR: 'admin-courses-bulk-action-bar',
            UPDATE_STATE_BTN: 'admin-courses-update-state-btn',
            // Curriculum editor
            ADD_MODULE_BTN: 'admin-courses-add-module-btn',
            ADD_LESSON_BTN: 'admin-courses-add-lesson-btn',
            SAVE_LESSON_CHANGES_BTN: 'admin-courses-save-lesson-changes-btn',
            DELETE_LESSON_BTN: 'admin-courses-delete-lesson-btn',
            SAVE_MODULE_CHANGES_BTN: 'admin-courses-save-module-changes-btn',
            DELETE_MODULE_BTN: 'admin-courses-delete-module-btn',
            MODULE_TITLE_INPUT: 'admin-courses-module-title-input',
            LESSON_TITLE_INPUT: 'admin-courses-lesson-title-input',
            LESSON_MENTOR_INPUT: 'admin-courses-lesson-mentor-input',
            LESSON_DESCRIPTION_INPUT: 'admin-courses-lesson-description-input',
            DRAGGABLE_MODULE: 'admin-courses-draggable-module',
            DRAGGABLE_MODULE_HEADER: 'admin-courses-draggable-module-header',
            DRAGGABLE_MODULE_TITLE: 'admin-courses-draggable-module-title',
            DRAGGABLE_LESSON: 'admin-courses-draggable-lesson',
            DRAGGABLE_LESSON_TITLE: 'admin-courses-draggable-lesson-title',
            VIDEO_CONTENT_INPUT: 'admin-courses-video-content-input',
            ADD_LESSON_MODAL_SUBMIT_BTN: 'admin-courses-add-lesson-modal-submit-btn',
            ADD_LESSON_MODAL_CANCEL_BTN: 'admin-courses-add-lesson-modal-cancel-btn',
            ADD_MODULE_MODAL_SUBMIT_BTN: 'admin-courses-add-module-modal-submit-btn',
            ADD_MODULE_MODAL_CANCEL_BTN: 'admin-courses-add-module-modal-cancel-btn',
            // Edit-page tabs
            CURRICULUM_TAB: 'admin-courses-curriculum-tab',
            SETTINGS_TAB: 'admin-courses-settings-tab',
            AI_SETTINGS_TAB: 'admin-courses-ai-settings-tab',
            STATE_TAB: 'admin-courses-state-tab',
            // Duplicate
            DUPLICATE_BTN: 'admin-courses-duplicate-btn',
            DUPLICATE_DIALOG: 'admin-courses-duplicate-dialog',
            DUPLICATE_TITLE_INPUT: 'admin-courses-duplicate-title-input',
            DUPLICATE_CONFIRM_BTN: 'admin-courses-duplicate-confirm-btn',
            DUPLICATE_CANCEL_BTN: 'admin-courses-duplicate-cancel-btn',
        },
        EVENTS: {
            ADD_EVENT_BTN: 'admin-add-event-btn',
            STATE_DROPDOWN: 'event-state-dropdown',
            ACCESS_TIER_DROPDOWN: 'event-access-tier-dropdown',
            UPDATE_ACCESS_TIER_BTN: 'event-update-access-tier-btn',
            UPDATE_STATE_BTN: 'admin-events-update-state-btn',
            EVENT_LINK_INPUT: 'eventLink-input',
            RECORDING_LINK_INPUT: 'admin-events-recording-link-input',
            PREVIEW_RECORDING_LINK_INPUT: 'admin-events-preview-recording-link-input',
            PREVIEW_CUTOFF_INPUT: 'admin-events-preview-cutoff-input',
            APPROVE_PREVIEW_CHECKBOX: 'admin-events-approve-preview-checkbox',
            TITLE_INPUT: 'admin-events-title-input',
            TITLE_ERROR: 'admin-events-title-error',
            DESCRIPTION_INPUT: 'admin-events-description-input',
            MENTOR_SELECT: 'admin-events-mentor-select',
            TIME_SELECT: 'admin-events-time-select',
            DURATION_SELECT: 'admin-events-duration-select',
            // Listing-page tabs
            UPCOMING_EVENTS_TAB: 'admin-events-upcoming-tab',
            ONGOING_EVENTS_TAB: 'admin-events-ongoing-tab',
            COMPLETED_EVENTS_TAB: 'admin-events-completed-tab',
            DRAFT_TAB: 'admin-events-draft-tab',
            ARCHIVED_TAB: 'admin-events-archived-tab',
            CARD_VIEW_TAB: 'admin-events-card-view-tab',
            TABLE_VIEW_TAB: 'admin-events-table-view-tab',
            EDIT_BTN: 'admin-events-edit-btn',
            THUMBNAIL_UPLOAD: 'admin-events-thumbnail-upload',
            // Edit-page tabs
            EDIT_EVENT_TAB: 'admin-events-edit-tab',
            STATE_TAB: 'admin-events-state-tab',
        },
        VIDEOS: {
            IMPORT_VIDEO_BTN: 'admin-import-video-btn',
            CARD: 'admin-video-card',
            CARD_VIEW_TAB: 'admin-videos-card-view-tab',
            TABLE_VIEW_TAB: 'admin-videos-table-view-tab',
            EDIT_BTN: 'admin-videos-edit-btn',
            TITLE_INPUT: 'admin-videos-title-input',
            TITLE_ERROR: 'admin-videos-title-error',
            DESCRIPTION_TEXTAREA: 'admin-videos-description-textarea',
            URL_INPUT: 'admin-videos-url-input',
            URL_ERROR: 'admin-videos-url-error',
            SAVE_BTN: 'admin-videos-save-btn',
            COUNT_STATUS: 'admin-videos-count-status',
            IMPORT_URL_INPUT: 'admin-videos-import-url-input',
            IMPORT_URL_ERROR: 'admin-videos-import-url-error',
            IMPORT_SUBMIT_BTN: 'admin-videos-import-submit-btn',
            SETTINGS: 'admin-videos-settings',
            SYNC_BTN: 'admin-videos-sync-btn',
        },
        SCENARIOS: {
            ADD_SCENARIO_BTN: 'admin-add-scenario-btn',
            STATE_DROPDOWN: 'scenario-state-dropdown',
            ACCESS_TIER_DROPDOWN: 'scenario-access-tier-dropdown',
            UPDATE_ACCESS_TIER_BTN: 'scenario-update-access-tier-btn',
            UPDATE_STATE_BTN: 'admin-scenarios-update-state-btn',
            // Listing-page tabs
            SCENARIOS_TAB: 'admin-scenarios-tab',
            PENDING_TAB: 'admin-scenarios-pending-tab',
            DRAFT_TAB: 'admin-scenarios-draft-tab',
            CARD_VIEW_TAB: 'admin-scenarios-card-view-tab',
            TABLE_VIEW_TAB: 'admin-scenarios-table-view-tab',
            CARD: 'admin-scenario-card',
            CARD_LIST: 'admin-scenarios-card-list',
            // Edit-page tabs
            SCENARIO_TAB: 'admin-scenarios-scenario-tab',
            STATE_TAB: 'admin-scenarios-state-tab',
            UPDATE_MODAL_UPDATE_BTN: 'admin-scenarios-update-modal-update-btn',
            TITLE_INPUT: 'admin-scenarios-title-input',
            DESCRIPTION_INPUT: 'admin-scenarios-description-input',
            TITLE_ERROR: 'admin-scenarios-title-error',
            DELETE_BTN: 'admin-scenarios-delete-btn',
        },
        FEATURE_FLAGS: {
            ADD_FEATURE_FLAG_BTN: 'admin-add-feature-flag-btn',
            EDIT_BTN: 'admin-ff-edit-btn',
            PUBLISH_BTN: 'admin-ff-publish-btn',
            ARCHIVE_BTN: 'admin-ff-archive-btn',
            // Listing-page tabs
            FEATURE_FLAGS_TAB: 'admin-feature-flags-tab',
            IN_DRAFT_TAB: 'admin-feature-flags-in-draft-tab',
            ARCHIVED_TAB: 'admin-feature-flags-archived-tab',
            PAGE_PREV: 'admin-feature-flags-page-prev',
            PAGE_NEXT: 'admin-feature-flags-page-next',
            PAGE_LABEL: 'admin-feature-flags-page-label',
            PAGE_TOTAL: 'admin-feature-flags-page-total',
            // Form inputs
            TITLE_INPUT: 'admin-feature-flag-title-input',
            TITLE_ERROR: 'admin-feature-flag-title-error',
            DESCRIPTION_INPUT: 'admin-feature-flag-description-input',
            CREATE_SUBMIT_BTN: 'admin-feature-flag-create-submit-btn',
            UPDATE_SUBMIT_BTN: 'admin-feature-flag-update-submit-btn',
        },
        CERTIFICATES: {
            PAGE: 'admin-certificates-page',
            SEARCH_INPUT: 'admin-certificates-search-input',
            STATUS_FILTER: 'admin-certificates-status-filter',
            YEAR_FILTER: 'admin-certificates-year-filter',
            TABLE: 'admin-certificates-table',
            ISSUE_BUTTON: 'admin-certificates-issue-button',
            ISSUE_DIALOG: 'admin-certificates-issue-dialog',
            ISSUE_STUDENT_INPUT: 'admin-certificates-issue-student-input',
            ISSUE_MENTOR_INPUT: 'admin-certificates-issue-mentor-input',
            ISSUE_PROGRAM_NAME_INPUT: 'admin-certificates-issue-program-name-input',
            ISSUE_FOUNDER_NAME_INPUT: 'admin-certificates-issue-founder-name-input',
            ISSUE_MENTOR_NAME_INPUT: 'admin-certificates-issue-mentor-name-input',
            ISSUE_MENTOR_TITLE_INPUT: 'admin-certificates-issue-mentor-title-input',
            ISSUE_SUBMIT_BUTTON: 'admin-certificates-issue-submit-button',
            ACTION_AUDIT_BUTTON: 'admin-certificates-action-audit-button',
            ACTION_DOWNLOAD_BUTTON: 'admin-certificates-action-download-button',
            ACTION_REVOKE_BUTTON: 'admin-certificates-action-revoke-button',
            ACTION_SUSPEND_BUTTON: 'admin-certificates-action-suspend-button',
            ACTION_REACTIVATE_BUTTON: 'admin-certificates-action-reactivate-button',
            AUDIT_DIALOG: 'admin-certificates-audit-dialog',
            REASON_DIALOG: 'admin-certificates-reason-dialog',
            REASON_TEXTAREA: 'admin-certificates-reason-textarea',
            REASON_SUBMIT_BUTTON: 'admin-certificates-reason-submit-button',
            REACTIVATE_DIALOG: 'admin-certificates-reactivate-dialog',
        },
        MBA_OPERATIONS: {
            PAGE: 'admin-mba-operations-page',
            SEARCH_INPUT: 'admin-mba-operations-search-input',
            CLEAR_FILTERS_BUTTON: 'admin-mba-operations-clear-filters-button',
            ACCESS_FILTER: 'admin-mba-operations-access-filter',
            PURCHASE_FILTER: 'admin-mba-operations-purchase-filter',
            PAYMENT_FILTER: 'admin-mba-operations-payment-filter',
            PROGRESS_FILTER: 'admin-mba-operations-progress-filter',
            CERTIFICATE_FILTER: 'admin-mba-operations-certificate-filter',
            FLAG_FILTER: 'admin-mba-operations-flag-filter',
            TABLE: 'admin-mba-operations-table',
            EMPTY_STATE: 'admin-mba-operations-empty-state',
            VIEW_DETAILS_BUTTON: 'admin-mba-operations-view-details-button',
            LOAD_MORE_BUTTON: 'admin-mba-operations-load-more-button',
            DETAIL_DIALOG: 'admin-mba-operations-detail-dialog',
            REPLAY_REASON_INPUT: 'admin-mba-operations-replay-reason-input',
            REPLAY_BUTTON: 'admin-mba-operations-replay-button',
        },
        PAYMENT_DISPUTES: {
            PAGE: 'admin-payment-disputes-page',
            TABLE: 'admin-payment-disputes-table',
            EMPTY_STATE: 'admin-payment-disputes-empty-state',
            ERROR_STATE: 'admin-payment-disputes-error-state',
            CLEAR_BLOCK_BUTTON: 'admin-payment-disputes-clear-block-button',
            CLEAR_BLOCK_DIALOG: 'admin-payment-disputes-clear-block-dialog',
            CLEAR_BLOCK_REASON_INPUT: 'admin-payment-disputes-clear-block-reason-input',
            CLEAR_BLOCK_CONFIRM_BUTTON: 'admin-payment-disputes-clear-block-confirm-button',
            RESPONSE_QUEUE: 'admin-payment-disputes-response-queue',
            RESPONSE_QUEUE_EMPTY_STATE: 'admin-payment-disputes-response-queue-empty-state',
            RESPONSE_QUEUE_ERROR_STATE: 'admin-payment-disputes-response-queue-error-state',
        },
        MEETING_REFUND_JOBS: {
            PAGE: 'admin-meeting-refund-jobs-page',
            TABLE: 'admin-meeting-refund-jobs-table',
            EMPTY_STATE: 'admin-meeting-refund-jobs-empty-state',
            ERROR_STATE: 'admin-meeting-refund-jobs-error-state',
            ISSUE_REFUND_BUTTON: 'admin-meeting-refund-jobs-issue-refund-button',
            CLOSE_WITHOUT_REFUND_BUTTON: 'admin-meeting-refund-jobs-close-button',
            REPLAY_DEAD_BUTTON: 'admin-meeting-refund-jobs-replay-dead-button',
            NOTE_INPUT: 'admin-meeting-refund-jobs-note-input',
        },
        MENTORS: {
            ADD_MENTOR_BTN: 'admin-add-mentor-btn',
            EDIT_BTN: 'admin-mentors-edit-btn',
            SAVE_BTN: 'admin-mentors-save-btn',
            CONVERT_TO_STUDENT_BTN: 'admin-mentors-convert-to-student-btn',
            CONVERT_TO_STUDENT_CONFIRM_BTN: 'admin-mentors-convert-to-student-confirm-btn',
            DEMOTE_BUTTON: 'admin-mentor-demote-btn',
            REVOKE_BUTTON: 'admin-mentor-revoke-btn',
            RESEND_INVITE_BUTTON: 'admin-mentor-resend-invite-btn',
            TABLE: 'admin-mentors-table',
            TABLE_COLUMNS: {
                EMAIL: 'admin-mentors-table-column-email',
                ASSOCIATIONS: 'admin-mentors-table-column-associations',
                ACTIONS: 'admin-mentors-table-column-actions',
            },
            TABLE_CELLS: {
                EMAIL: 'admin-mentors-table-cell-email',
            },
            ADD_DIALOG: 'admin-add-mentor-dialog',
            ADD_DIALOG_CONTINUE_BTN: 'admin-add-mentor-dialog-continue-btn',
            ADD_DIALOG_CANCEL_BTN: 'admin-add-mentor-dialog-cancel-btn',
            USER_DROPDOWN: 'admin-add-mentor-user-dropdown',
            USER_ERROR: 'admin-add-mentor-user-error',
            PAGE_PREV: 'admin-mentors-page-prev',
            PAGE_NEXT: 'admin-mentors-page-next',
            PAGE_LABEL: 'admin-mentors-page-label',
            PAGE_TOTAL: 'admin-mentors-page-total',
            EDIT_BUTTON: 'admin-mentor-edit-profile-btn',
            VIEW_ASSOCIATIONS_BUTTON: 'admin-mentor-view-associations-btn',
            EDIT_DIALOG: 'admin-mentor-edit-profile-dialog',
            EDIT_DIALOG_SAVE_BTN: 'admin-mentor-edit-profile-save-btn',
            EDIT_DIALOG_CANCEL_BTN: 'admin-mentor-edit-profile-cancel-btn',
            BIO_TEXTAREA: 'admin-mentor-profile-bio-textarea',
            PRIMARY_CATEGORY_DROPDOWN: 'admin-mentor-profile-primary-category',
            SECONDARY_CATEGORIES_DROPDOWN: 'admin-mentor-profile-secondary-categories',
            CURRENT_SERVICES: 'admin-mentor-profile-current-services',
            LOAD_ERROR: 'admin-mentor-profile-load-error',
            SAVE_ERROR: 'admin-mentor-profile-save-error',
            BULK_UPLOAD_BTN: 'admin-mentors-bulk-upload-btn',
            BULK_UPLOAD_DIALOG: 'admin-mentors-bulk-upload-dialog',
            BULK_UPLOAD_PREVIEW_DIALOG: 'admin-mentors-bulk-upload-preview-dialog',
            BULK_UPLOAD_REASON_INPUT: 'admin-mentors-bulk-upload-reason-input',
            BULK_UPLOAD_ROLE_SUMMARY: 'admin-mentors-bulk-upload-role-summary',
            BULK_UPLOAD_FILE_INPUT: 'admin-mentors-bulk-upload-file-input',
            BULK_UPLOAD_RESULTS_MODAL: 'admin-mentors-bulk-upload-results-modal',
            BULK_UPLOAD_RESULTS_FAILED_ROW: 'admin-mentors-bulk-upload-results-failed-row',
            BULK_UPLOAD_RESULTS_CLOSE_BTN: 'admin-mentors-bulk-upload-results-close-btn',
            ASSOCIATION_SUMMARY: {
                SECTION: 'admin-mentor-association-summary',
                PRIMARY_COUNT: 'admin-mentor-association-primary-count',
                SECONDARY_COUNT: 'admin-mentor-association-secondary-count',
                OTHER_COUNT: 'admin-mentor-association-other-count',
                ITEM: 'admin-mentor-association-item',
                ITEM_LINK: 'admin-mentor-association-item-link',
                ITEM_CHECKBOX: 'admin-mentor-association-item-checkbox',
                SELECT_ALL: 'admin-mentor-association-select-all',
                CLEAR_SELECTION: 'admin-mentor-association-clear-selection',
                REASSIGN_SECTION: 'admin-mentor-reassign-section',
                REASSIGN_MENTOR_DROPDOWN: 'admin-mentor-reassign-mentor-dropdown',
                REASSIGN_SUBMIT: 'admin-mentor-reassign-submit',
                REPLACEMENT_LOAD_ERROR: 'admin-mentor-replacement-load-error',
                REPLACEMENT_RETRY: 'admin-mentor-replacement-retry',
            },
            ORPHANED_CONTENT: {
                SECTION: 'admin-mentor-orphaned-content',
                TOTAL: 'admin-mentor-orphaned-content-total',
                ITEM: 'admin-mentor-orphaned-content-item',
                REFRESH: 'admin-mentor-orphaned-content-refresh',
                REASON_TAB_ALL: 'admin-mentor-orphaned-reason-all',
                REASON_TAB_ROLE_MISSING: 'admin-mentor-orphaned-reason-role-missing',
                REASON_TAB_PRIMARY_MISSING: 'admin-mentor-orphaned-reason-primary-missing',
                REASON_TAB_INACTIVE: 'admin-mentor-orphaned-reason-inactive',
                REASON_TAB_OTHER: 'admin-mentor-orphaned-reason-other',
                TYPE_TAB_ALL: 'admin-mentor-orphaned-type-all',
                TYPE_TAB_COURSE: 'admin-mentor-orphaned-type-course',
                TYPE_TAB_LIVE_EVENT: 'admin-mentor-orphaned-type-live-event',
                TYPE_TAB_MENTORSHIP_EVENT: 'admin-mentor-orphaned-type-mentorship-event',
                TYPE_TAB_DOCUMENT: 'admin-mentor-orphaned-type-document',
                TYPE_TAB_EMAIL: 'admin-mentor-orphaned-type-email',
                PAGE_PREV: 'admin-mentor-orphaned-page-prev',
                PAGE_NEXT: 'admin-mentor-orphaned-page-next',
                PAGE_LABEL: 'admin-mentor-orphaned-page-label',
                LOAD_ERROR: 'admin-mentor-orphaned-load-error',
                RETRY: 'admin-mentor-orphaned-retry',
            },
        },
        ROLE_TRANSITION: {
            DIALOG: 'admin-role-transition-dialog',
            REASON_INPUT: 'admin-role-transition-reason-input',
            TARGET_ROLE_DROPDOWN: 'admin-role-transition-target-role-dropdown',
            MENTOR_ACK: 'admin-role-transition-mentor-ack',
            REASSIGNMENT_ACK: 'admin-role-transition-reassignment-ack',
            CONFIRM_BUTTON: 'admin-role-transition-confirm-button',
            CANCEL_BUTTON: 'admin-role-transition-cancel-button',
            IMPACT_LIST: 'admin-role-transition-impact-list',
            BLOCKING_LIST: 'admin-role-transition-blocking-list',
            ASSOCIATION_OUTCOME: {
                SECTION: 'admin-role-transition-association-outcome',
                MENTOR_DROPDOWN: 'admin-role-transition-reassign-mentor-dropdown',
                REASSIGN_BUTTON: 'admin-role-transition-reassign-button',
                SECONDARY_HINT: 'admin-role-transition-secondary-hint',
                REMOVE_SECONDARY_BUTTON: 'admin-role-transition-remove-secondary-button',
                REPLACEMENT_LOAD_ERROR: 'admin-role-transition-replacement-load-error',
                REPLACEMENT_RETRY: 'admin-role-transition-replacement-retry',
            },
        },
        PARTNERS: {
            ADD_PARTNER_BTN: 'admin-add-partner-btn',
            SEARCH_INPUT: 'admin-partners-search-input',
            EMPTY_STATE: 'admin-partners-empty-state',
            USER_SEARCH_INPUT: 'admin-partner-users-search-input',
            USER_ACCESS_FILTER: 'admin-partner-users-access-filter',
            ACTION_MENU_TRIGGER: 'admin-partner-action-menu-trigger',
            ACTION_MENU_ITEM: 'admin-partner-action-menu-item',
            TABLE_ROW: 'admin-partner-table-row',
            INVITE_ADMIN: {
                BUTTON: 'admin-partner-invite-admin-button',
                DIALOG: 'admin-partner-invite-admin-dialog',
                EMAIL_INPUT: 'admin-partner-invite-admin-email-input',
                FIRST_NAME_INPUT: 'admin-partner-invite-admin-first-name-input',
                LAST_NAME_INPUT: 'admin-partner-invite-admin-last-name-input',
                SUBMIT_BUTTON: 'admin-partner-invite-admin-submit-button',
                ERROR: 'admin-partner-invite-admin-error',
            },
            REMOVE_MANAGER: {
                CONFIRM_BUTTON: 'admin-partner-remove-manager-confirm-button',
                ROLE_DROPDOWN: 'admin-partner-remove-manager-role-dropdown',
            },
            ACCESS_SUMMARY: {
                SECTION: 'admin-partner-access-summary',
                STANDARD: 'admin-partner-access-summary-standard',
                PAID: 'admin-partner-access-summary-paid',
                SUBSCRIBED: 'admin-partner-access-summary-subscribed',
                MBA: 'admin-partner-access-summary-mba',
                CERTIFIED: 'admin-partner-access-summary-certified',
                TOP_500: 'admin-partner-access-summary-top-500',
            },
            LICENSE_SUMMARY: {
                SECTION: 'admin-partner-license-summary',
                ASSIGN_BUTTON: 'admin-partner-license-assign-button',
                EDIT_BUTTON: 'admin-partner-license-edit-button',
                ASSIGN_SUBMIT_BUTTON: 'admin-partner-license-assign-submit-button',
                EDIT_SUBMIT_BUTTON: 'admin-partner-license-edit-submit-button',
                TYPE_VALUE: 'admin-partner-license-type-value',
                STRUCTURE_VALUE: 'admin-partner-license-structure-value',
                DURATION_VALUE: 'admin-partner-license-duration-value',
                STARTS_VALUE: 'admin-partner-license-starts-value',
                EXPIRES_VALUE: 'admin-partner-license-expires-value',
                SEATS_VALUE: 'admin-partner-license-seats-value',
                STATUS_VALUE: 'admin-partner-license-status-value',
                NOTES_VALUE: 'admin-partner-license-notes-value',
                SCOPE_CHIP: 'admin-partner-license-scope-chip',
                SCOPE_CHIP_CONTAINER: 'admin-partner-license-scope-chip-container',
                SCOPE_CHIP_REMOVE: 'admin-partner-license-scope-chip-remove',
                SCOPE_FULL_MBA_STATE: 'admin-partner-license-scope-full-mba-state',
                SCOPE_COURSE_STATE: 'admin-partner-license-scope-course-state',
                SCOPE_WORKSHOP_STATE: 'admin-partner-license-scope-workshop-state',
                REMOVAL_CONFIRM_BUTTON: 'admin-partner-license-scope-removal-confirm-button',
                BLOCKING_DIALOG: 'admin-partner-license-scope-blocking-dialog',
                BLOCKING_DIALOG_ROW: 'admin-partner-license-scope-blocking-dialog-row',
                BLOCKING_DIALOG_MANAGE_BUTTON: 'admin-partner-license-scope-blocking-dialog-manage-button',
                BLOCKING_DIALOG_CLOSE_BUTTON: 'admin-partner-license-scope-blocking-dialog-close-button',
                SCOPE_PICKER: 'admin-partner-license-scope-picker',
                SCOPE_PICKER_SEARCH_HINT: 'admin-partner-license-scope-picker-search-hint',
                SCOPE_PICKER_CAP_NOTICE: 'admin-partner-license-scope-picker-cap-notice',
                SCOPE_PICKER_LOAD_ERROR: 'admin-partner-license-scope-picker-load-error',
                SCOPE_PICKER_LOAD_RETRY: 'admin-partner-license-scope-picker-load-retry',
                SCOPE_PICKER_SELECTED_LOAD_ERROR: 'admin-partner-license-scope-picker-selected-load-error',
                SCOPE_PICKER_SELECTED_LOAD_RETRY: 'admin-partner-license-scope-picker-selected-load-retry',
                USER_ASSIGNEE_LOAD_ERROR: 'admin-partner-license-user-assignee-load-error',
                USER_ASSIGNEE_LOAD_RETRY: 'admin-partner-license-user-assignee-load-retry',
                COHORT_ASSIGNEE_LOAD_ERROR: 'admin-partner-license-cohort-assignee-load-error',
                COHORT_ASSIGNEE_LOAD_RETRY: 'admin-partner-license-cohort-assignee-load-retry',
                FORM: {
                    LICENSE_TYPE_INPUT: 'admin-partner-license-type-input',
                    START_DATE_INPUT: 'admin-partner-license-start-date-input',
                    SEAT_LIMIT_INPUT: 'admin-partner-license-seat-limit-input',
                    NOTES_INPUT: 'admin-partner-license-notes-input',
                },
            },
            LICENSE_REQUESTS: {
                SECTION: 'admin-partner-license-requests',
                ROW: 'admin-partner-license-request-row',
                ACKNOWLEDGE_BUTTON: 'admin-partner-license-request-acknowledge-button',
                RESOLVE_BUTTON: 'admin-partner-license-request-resolve-button',
                REJECT_BUTTON: 'admin-partner-license-request-reject-button',
                RESOLVE_DIALOG: 'admin-partner-license-request-resolve-dialog',
                APPLY_CHANGES_SWITCH: 'admin-partner-license-request-apply-changes-switch',
                SEAT_LIMIT_INPUT: 'admin-partner-license-request-seat-limit-input',
                INTERNAL_NOTE_INPUT: 'admin-partner-license-request-internal-note-input',
                RESOLVE_SUBMIT_BUTTON: 'admin-partner-license-request-resolve-submit-button',
                QUOTE_BUTTON: 'admin-partner-license-request-quote-button',
                CHECKOUT_BUTTON: 'admin-partner-license-request-checkout-button',
                PRICE_DIALOG: 'admin-partner-license-request-price-dialog',
                PRICE_INPUT: 'admin-partner-license-request-price-input',
                CURRENCY_INPUT: 'admin-partner-license-request-currency-input',
                PRICE_SUBMIT_BUTTON: 'admin-partner-license-request-price-submit-button',
                REQUEST_ROW_PRICE: 'admin-partner-license-request-row-price',
            },
            FORM: {
                NAME_INPUT: 'partner-name-input',
                NAME_ERROR: 'partner-name-error',
                DOMAIN_INPUT: 'partner-domain-input',
                DOMAIN_ERROR: 'partner-domain-error',
                PARTNER_TYPE_DROPDOWN: 'partner-type-dropdown',
                INDUSTRY_DROPDOWN: 'partner-industry-dropdown',
                SIZE_DROPDOWN: 'partner-size-dropdown',
                CONTACT_EMAIL_INPUT: 'partner-contact-email-input',
                CONTACT_EMAIL_ERROR: 'partner-contact-email-error',
                WEBSITE_INPUT: 'partner-website-input',
                DESCRIPTION_INPUT: 'partner-description-input',
                MAX_SEATS_INPUT: 'partner-max-seats-input',
            },
        },
        ROLES_PERMISSIONS: {
            ADD_ADMIN_BTN: 'admin-add-admin-btn',
            BULK_UPLOAD_BTN: 'admin-roles-bulk-upload-btn',
            ADD_ADMIN_EMAIL_INPUT: 'admin-add-admin-email-input',
            ADD_ADMIN_REASON_INPUT: 'admin-add-admin-reason-input',
            ADD_ADMIN_CONFIRM_BTN: 'admin-add-admin-confirm-btn',
            BULK_UPLOAD_DIALOG: 'admin-roles-bulk-upload-dialog',
            BULK_UPLOAD_PREVIEW_DIALOG: 'admin-roles-bulk-upload-preview-dialog',
            BULK_UPLOAD_REASON_INPUT: 'admin-bulk-upload-reason-input',
            BULK_UPLOAD_ROLE_SUMMARY: 'admin-roles-bulk-upload-role-summary',
            BULK_UPLOAD_FILE_INPUT: 'admin-roles-bulk-upload-file-input',
            BULK_UPLOAD_RESULTS_MODAL: 'admin-roles-bulk-upload-results-modal',
            DEMOTE_BUTTON: 'admin-demote-admin-btn',
            RESEND_INVITE_BUTTON: 'admin-resend-invite-btn',
            ADMINS_HEADING: 'admin-roles-admins-heading',
        },
        TEMPLATES: {
            STATE_DROPDOWN: 'template-state-dropdown',
            ACCESS_TIER_DROPDOWN: 'template-access-tier-dropdown',
            UPDATE_ACCESS_TIER_BTN: 'template-update-access-tier-btn',
            // Form inputs
            TITLE_INPUT: 'template-title-input',
            TITLE_ERROR: 'template-title-error',
            DESCRIPTION_INPUT: 'template-description-input',
            VIDEO_URL_INPUT: 'template-video-url-input',
            CATEGORY_SELECT: 'template-category-select',
            MENTOR_SELECT: 'template-mentor-select',
            FILE_UPLOAD: 'template-file-upload',
            FILE_UPLOAD_INPUT: 'template-file-upload-input',
            THUMBNAIL_UPLOAD: 'admin-templates-thumbnail-upload',
            // Email template fields
            EMAIL_SUBJECT_INPUT: 'template-email-subject-input',
            EMAIL_BODY_INPUT: 'template-email-body-input',
            LINKEDIN_SUBJECT_INPUT: 'template-linkedin-subject-input',
            LINKEDIN_BODY_INPUT: 'template-linkedin-body-input',
            // Buttons
            CREATE_DOCUMENT_BTN: 'template-create-document-btn',
            CREATE_EMAIL_BTN: 'template-create-email-btn',
            ADD_BTN: 'template-add-btn',
            SAVE_BTN: 'template-save-btn',
            UPDATE_STATE_BTN: 'template-update-state-btn',
            // Listing tabs (Tools & Templates index)
            LISTING_DOCUMENT_TYPE_TAB: 'admin-templates-document-type-tab',
            LISTING_EMAIL_TYPE_TAB: 'admin-templates-email-type-tab',
            LISTING_PUBLISHED_STATE_TAB: 'admin-templates-published-state-tab',
            LISTING_IN_DRAFT_TAB: 'admin-templates-in-draft-tab',
            LISTING_ARCHIVED_TAB: 'admin-templates-archived-tab',
            CARD_VIEW_TAB: 'admin-templates-card-view-tab',
            TABLE_VIEW_TAB: 'admin-templates-table-view-tab',
            BULK_ACTION_BAR: 'admin-templates-bulk-action-bar',
            EDIT_BTN: 'admin-templates-edit-btn',
            DELETE_BTN: 'admin-templates-delete-btn',
            DUPLICATE_BTN: 'admin-templates-duplicate-btn',
            DUPLICATE_DIALOG: 'admin-templates-duplicate-dialog',
            DUPLICATE_TITLE_INPUT: 'admin-templates-duplicate-title-input',
            DUPLICATE_CONFIRM_BTN: 'admin-templates-duplicate-confirm-btn',
            DUPLICATE_CANCEL_BTN: 'admin-templates-duplicate-cancel-btn',
            // Edit-page tabs
            EDIT_DOCUMENT_TAB: 'admin-templates-edit-document-tab',
            EDIT_EMAIL_TAB: 'admin-templates-edit-email-tab',
            AI_SETTINGS_TAB: 'admin-templates-ai-settings-tab',
            STATE_EDITOR_TAB: 'admin-templates-state-editor-tab',
            // Tabs
            DOCUMENTS_TAB: 'template-documents-tab',
            EMAIL_TAB: 'template-email-tab',
            LINKEDIN_TAB: 'template-linkedin-tab',
        },
        PROTECTED_DOWNLOADS: {
            ADD_BTN: 'admin-protected-downloads-add-btn',
            EDIT_BTN: 'admin-protected-downloads-edit-btn',
            COPY_URL_BTN: 'admin-protected-downloads-copy-url-btn',
            PREVIEW_BTN: 'admin-protected-downloads-preview-btn',
            TABLE: 'admin-protected-downloads-table',
            EMPTY_STATE: 'admin-protected-downloads-empty',
            ERROR_STATE: 'admin-protected-downloads-error',
            LOADING_STATE: 'admin-protected-downloads-loading',
            ROW: 'admin-protected-downloads-row',
            PERMANENT_URL_CELL: 'admin-protected-downloads-permanent-url',
            SLUG_INPUT: 'protected-download-slug-input',
            DISPLAY_NAME_INPUT: 'protected-download-display-name-input',
            OWNER_SELECT: 'protected-download-owner-select',
            INHERITED_ACCESS: 'protected-download-inherited-access',
            DISPOSITION_SELECT: 'protected-download-disposition-select',
            SUBMIT_BTN: 'protected-download-submit-btn',
            PUBLISH_BTN: 'protected-download-publish-btn',
            ARCHIVE_BTN: 'protected-download-archive-btn',
            REPUBLISH_BTN: 'protected-download-republish-btn',
            REPLACE_RESOURCE_BTN: 'protected-download-replace-resource-btn',
            DELETE_BTN: 'protected-download-delete-btn',
            DELETE_CONFIRM_INPUT: 'protected-download-delete-confirm-input',
            HISTORY_TABLE: 'protected-download-history-table',
            DETAILS: 'protected-download-details',
            STATUS: 'protected-download-status',
            SLUG: 'protected-download-slug',
            FILE_INPUT: 'protected-download-file-input',
            REPLACEMENT_FILE_INPUT: 'protected-download-replacement-file-input',
        },
        DEALS: {
            ADD_DEAL_BTN: 'admin-add-deal-btn',
            MANAGE_ORDER_BTN: 'admin-deals-manage-order-btn',
            ORDER: {
                PROGRESS: 'admin-deal-order-progress',
                LOAD_FAILURE: 'admin-deal-order-load-failure',
                RETRY_BTN: 'admin-deal-order-retry-btn',
                // SortableList root; rows, handles, move buttons and the live region derive `-item`, `-handle`,
                // `-move-up`, `-move-down`, `-position`, `-live-region` and `-disabled-reason` suffixes.
                LIST: 'admin-deal-order-list',
                ROW_TITLE: 'admin-deal-order-row-title',
                ROW_STATUS: 'admin-deal-order-row-status',
                ROW_CATEGORY: 'admin-deal-order-row-category',
            },
            EDIT_BTN: 'admin-deals-edit-btn',
            DELETE_BTN: 'admin-deals-delete-btn',
            DESCRIPTION_TEXTAREA: 'deal-description-textarea',
            CATEGORY_SELECT: 'deal-category-select',
            LOGO_UPLOAD: 'admin-deals-logo-upload',
            LOGO_ERROR: 'admin-deals-logo-error',
            HOW_TO_USE_EDITOR: 'deal-how-to-use',
            HOW_TO_USE_INPUT: 'deal-how-to-use-input',
            TERMS_OF_SERVICE_EDITOR: 'deal-terms-of-service',
            TERMS_OF_SERVICE_INPUT: 'deal-terms-of-service-input',
            STATE_DROPDOWN: 'deal-state-dropdown',
            ACCESS_TIER_DROPDOWN: 'deal-access-tier-dropdown',
            RELATIONSHIP_SELECT: 'deal-relationship-select',
            RELATIONSHIP_FILTER: 'admin-deals-relationship-filter',
            RECOVERY_STATUS: 'admin-deals-recovery-status',
            STALE_ALERT: 'admin-deals-stale-alert',
            STALE_RELOAD_BTN: 'admin-deals-stale-reload-btn',
            LOAD_FAILURE: 'admin-deals-load-failure',
            LOAD_RETRY_BTN: 'admin-deals-load-retry-btn',
            // Listing-page tabs
            DEALS_TAB: 'admin-deals-tab',
            IN_DRAFT_TAB: 'admin-deals-in-draft-tab',
            ARCHIVED_TAB: 'admin-deals-archived-tab',
            CARD_VIEW_TAB: 'admin-deals-card-view-tab',
            TABLE_VIEW_TAB: 'admin-deals-table-view-tab',
            TABLE: 'admin-deals-table',
            BULK_ACTION_BAR: 'admin-deals-bulk-action-bar',
            TABLE_COLUMNS: {
                TITLE: 'admin-deals-table-column-title',
                DESCRIPTION: 'admin-deals-table-column-description',
                CATEGORY: 'admin-deals-table-column-category',
                VALUE: 'admin-deals-table-column-value',
                RELATIONSHIP: 'admin-deals-table-column-relationship',
                STATUS: 'admin-deals-table-column-status',
                ACCESS_TIER: 'admin-deals-table-column-access-tier',
                LAST_UPDATED: 'admin-deals-table-column-last-updated',
            },
            TABLE_CELLS: {
                TITLE: 'admin-deals-table-cell-title',
                DESCRIPTION: 'admin-deals-table-cell-description',
                CATEGORY: 'admin-deals-table-cell-category',
                VALUE: 'admin-deals-table-cell-value',
                RELATIONSHIP: 'admin-deals-table-cell-relationship',
                STATUS: 'admin-deals-table-cell-status',
                ACCESS_TIER: 'admin-deals-table-cell-access-tier',
                LAST_UPDATED: 'admin-deals-table-cell-last-updated',
            },
            DUPLICATE_BTN: 'admin-deals-duplicate-btn',
            DUPLICATE_DIALOG: 'admin-deals-duplicate-dialog',
            DUPLICATE_TITLE_INPUT: 'admin-deals-duplicate-title-input',
            DUPLICATE_CONFIRM_BTN: 'admin-deals-duplicate-confirm-btn',
            DUPLICATE_CANCEL_BTN: 'admin-deals-duplicate-cancel-btn',
            // Form inputs (auto-generated by SDSTextInput from the field `name` prop)
            TITLE_INPUT: 'title-input',
            TITLE_ERROR: 'title-error',
            VALUE_INPUT: 'value-input',
            VALUE_ERROR: 'value-error',
            VIDEO_URL_INPUT: 'videoUrl-input',
            WEBSITE_INPUT: 'website-input',
            WEBSITE_ERROR: 'website-error',
        },
        AI_INSTRUCTIONS: {
            ADD_BTN: 'admin-ai-instructions-add-btn',
            TABLE: 'admin-ai-instructions-table',
            FORM_TITLE: 'admin-ai-instructions-form-title',
            TITLE_INPUT: 'admin-ai-instructions-title-input',
            CONTENT_INPUT: 'admin-ai-instructions-content-input',
            SCOPE_INPUT: 'admin-ai-instructions-scope-input',
            SCOPE_ID_INPUT: 'admin-ai-instructions-scope-id-input',
            PRIORITY_INPUT: 'admin-ai-instructions-priority-input',
            ACTIVE_CHECKBOX: 'admin-ai-instructions-active-checkbox',
            TITLE_CELL: 'admin-ai-instructions-title-cell',
            EDIT_BTN: 'admin-ai-instructions-edit-btn',
            DELETE_BTN: 'admin-ai-instructions-delete-btn',
        },
        COMMUNITY: {
            PAGE: 'admin-community-page',
            PENDING_TAB: 'admin-community-pending-tab',
            APPROVED_TAB: 'admin-community-approved-tab',
            REJECTED_TAB: 'admin-community-rejected-tab',
            REPORTS_TAB: 'admin-community-reports-tab',
            CHANNELS_TAB: 'admin-community-channels-tab',
            SETTINGS_TAB: 'admin-community-settings-tab',
            SETTINGS_PANEL: 'admin-community-settings-panel',
            /** The Channels tab's own panel: the create/edit form and the channel list. */
            CHANNELS_PANEL: 'admin-community-channels-panel',
            SETTINGS_SAVE_BUTTON: 'admin-community-settings-save-button',
            SETTINGS_FIELD: 'admin-community-settings-field',
            CHANNEL_NAME_INPUT: 'admin-community-channel-name-input',
            CHANNEL_SLUG_INPUT: 'admin-community-channel-slug-input',
            CHANNEL_DESCRIPTION_INPUT: 'admin-community-channel-description-input',
            CHANNEL_ERROR_SUMMARY: 'admin-community-channel-error-summary',
            CHANNEL_CREATE_BUTTON: 'admin-community-channel-create-button',
            CHANNEL_SAVE_BUTTON: 'admin-community-channel-save-button',
            CHANNEL_PUBLISH_BUTTON: 'admin-community-channel-publish-button',
            CHANNEL_EDIT_BUTTON: 'admin-community-channel-edit-button',
            CHANNEL_ARCHIVE_BUTTON: 'admin-community-channel-archive-button',
            CHANNEL_DELETE_BUTTON: 'admin-community-channel-delete-button',
            CHANNEL_PRIMARY_CATEGORY_SELECT: 'admin-community-channel-primary-category',
            CHANNEL_COUNTRY_FIELD: 'admin-community-channel-country-field',
            CHANNEL_STATUS_FILTER: 'admin-community-channel-status-filter',
            CHANNEL_LIST_LOADING: 'admin-community-channel-list-loading',
            CHANNEL_LIST_EMPTY: 'admin-community-channel-list-empty',
            CHANNEL_LIST_ERROR: 'admin-community-channel-list-error',
            CHANNEL_LIST_RETRY: 'admin-community-channel-list-retry',
            CHANNEL_NEXT_PAGE_ERROR: 'admin-community-channel-next-page-error',
            CHANNEL_LOAD_MORE: 'admin-community-channel-load-more',
            POST_APPROVE_BUTTON: 'admin-community-post-approve-button',
            POST_REJECT_BUTTON: 'admin-community-post-reject-button',
            POSTS_PANEL: 'admin-community-posts-panel',
            POST_LIST_LOADING: 'admin-community-post-list-loading',
            POST_LIST_EMPTY: 'admin-community-post-list-empty',
            POST_LIST_ERROR: 'admin-community-post-list-error',
            POST_LIST_RETRY: 'admin-community-post-list-retry',
            POST_LOAD_MORE: 'admin-community-post-load-more',
            BULK_ACTION_BAR: 'admin-community-bulk-action-bar',
            REPORTS_PANEL: 'admin-community-reports-panel',
            REPORT_RESOLVE_BUTTON: 'admin-community-report-resolve-button',
            REPORT_DISMISS_BUTTON: 'admin-community-report-dismiss-button',
            REPORT_RESOLVE_NOTES: 'admin-community-report-resolve-notes',
            REPORT_RESOLVE_CONFIRM: 'admin-community-report-resolve-confirm',
        },
    },
    AI_SETTINGS: {
        INSTRUCTIONS_TEXTAREA: 'ai-instructions-textarea',
        SAVE_BTN: 'ai-settings-save-btn',
    },
    NOTIFICATIONS: {
        PAGE: 'notif-page',
        SECTION_ANNOUNCEMENTS: 'notif-section-announcements',
        SECTION_MENTIONS: 'notif-section-mentions',
        SECTION_SECTIONS: 'notif-section-sections',
        SECTION_DISPLAY: 'notif-section-display',
        LABEL_DEALS_DISCOUNTS: 'notif-label-deals-discounts',
        LABEL_TOOLS_TEMPLATES: 'notif-label-tools-templates',
        LABEL_LIVE_CALLS: 'notif-label-live-calls',
        LABEL_COMMUNITY_FEED: 'notif-label-community-feed',
        DISABLE_ALL: 'notif-disable-all',
        ANNOUNCEMENTS_COURSES: 'notif-announcements-courses',
        ANNOUNCEMENTS_LIVE_WORKSHOPS: 'notif-announcements-live-workshops',
        ANNOUNCEMENTS_DEALS_DISCOUNTS: 'notif-announcements-deals-discounts',
        ANNOUNCEMENTS_TOOLS_TEMPLATES: 'notif-announcements-tools-templates',
        ANNOUNCEMENTS_LIVE_CALLS: 'notif-announcements-live-calls',
        MENTIONS_FEED: 'notif-mentions-feed',
        MENTIONS_SCENARIOS: 'notif-mentions-scenarios',
        SECTIONS_ALERTS: 'notif-sections-alerts',
        SECTIONS_SCENARIOS: 'notif-sections-scenarios',
        SECTIONS_CALENDAR: 'notif-sections-calendar',
        CHANNEL_PUSH: 'notif-channel-push',
        CHANNEL_IN_APP: 'notif-channel-in-app',
        CHANNEL_EMAIL: 'notif-channel-email',
    },
    PARTNER: {
        CAPABILITIES_UNAVAILABLE: {
            PANEL: 'partner-capabilities-unavailable-panel',
            RETRY: 'partner-capabilities-unavailable-retry',
        },
        DASHBOARD: {
            PAGE: 'partner-dashboard-page',
            TITLE: 'partner-dashboard-title',
        },
        LICENSE: {
            PAGE: 'partner-license-page',
            SCOPE_ITEM: 'partner-license-scope-item',
            RENEWAL_STATUS: 'partner-license-renewal-status',
            TYPE_LABEL: 'partner-license-type-label',
            OVERVIEW_CARD: 'partner-license-overview-card',
            OVERVIEW_TYPE_LABEL: 'partner-license-overview-type-label',
            OVERVIEW_SCOPE_CHIP: 'partner-license-overview-scope-chip',
            OVERVIEW_SEATS: 'partner-license-overview-seats',
            REQUEST_BUTTON: 'partner-license-request-btn',
            REQUEST_DIALOG: 'partner-license-request-dialog',
            REQUEST_NOTE_INPUT: 'partner-license-request-note-input',
            REQUEST_ROW: 'partner-license-request-row',
            REQUEST_SUBMIT_BUTTON: 'partner-license-request-submit-btn',
            REQUEST_DONE_BUTTON: 'partner-license-request-done-btn',
            REQUEST_FORM_CANCEL_BUTTON: 'partner-license-request-form-cancel-btn',
            REQUEST_ROW_CANCEL_BUTTON: 'partner-license-request-row-cancel-btn',
            REQUEST_ROW_PAY_BUTTON: 'partner-license-request-row-pay-btn',
            REQUEST_ROW_PRICE: 'partner-license-request-row-price',
            REQUEST_SUCCESS: 'partner-license-request-success',
            ALERTS_CARD: 'partner-license-alerts-card',
            ALERT_ROW: 'partner-license-alert-row',
            ALERT_DISMISS_BUTTON: 'partner-license-alert-dismiss-btn',
        },
        BILLING: {
            PAGE: 'partner-billing-page',
            REQUEST_PLAN_CHANGE: 'partner-billing-request-plan-change',
            PLAN_NAME: 'partner-billing-plan-name',
            LICENSE_TYPE: 'partner-billing-license-type',
            CYCLE: 'partner-billing-cycle',
            TERM: 'partner-billing-term',
            SEATS: 'partner-billing-seats',
        },
        COHORTS: {
            PAGE: 'partner-cohorts-page',
            LIST_ITEM: 'partner-cohort-list-item',
            TITLE: 'partner-cohorts-title',
            CREATE_BUTTON: 'partner-cohorts-create-btn',
            FORM_DIALOG: 'partner-cohort-form-dialog',
            FORM_NAME_INPUT: 'partner-cohort-form-name-input',
            FORM_DESCRIPTION_INPUT: 'partner-cohort-form-description-input',
            FORM_SUBMIT_BUTTON: 'partner-cohort-form-submit-btn',
            DETAIL_PAGE: 'partner-cohort-detail-page',
            DETAIL_TITLE: 'partner-cohort-detail-title',
            EDIT_BUTTON: 'partner-cohort-edit-btn',
            ARCHIVE_BUTTON: 'partner-cohort-archive-btn',
            STATUS_BADGE: 'partner-cohort-status-badge',
            ADD_MEMBERS_BUTTON: 'partner-cohort-add-members-btn',
            ADD_MEMBERS_DIALOG: 'partner-cohort-add-members-dialog',
            ADD_MEMBERS_SELECT_TRIGGER: 'partner-cohort-add-members-select-trigger',
            ADD_MEMBERS_SELECT_CLOSE: 'partner-cohort-add-members-select-close',
            ADD_MEMBERS_OPTION_CHECKBOX: 'partner-cohort-add-members-option-checkbox',
            ADD_MEMBERS_SUBMIT_BUTTON: 'partner-cohort-add-members-submit-btn',
            ADD_MEMBERS_LOAD_ERROR: 'partner-cohort-add-members-load-error',
            ADD_MEMBERS_LOAD_RETRY: 'partner-cohort-add-members-load-retry',
            ADD_MEMBERS_EMPTY_HINT: 'partner-cohort-add-members-empty-hint',
            MEMBER_EMAIL_CELL: 'partner-cohort-member-email',
            MEMBER_ROW: 'partner-cohort-member-row',
            MEMBER_REMOVE_ACTION: 'partner-cohort-member-remove-action',
            CONTENT_SECTION: 'partner-cohort-content-section',
            CONTENT_SCOPE_ITEM: 'partner-cohort-content-scope-item',
            CONTENT_ASSIGN_BUTTON: 'partner-cohort-content-assign-btn',
            CONTENT_ASSIGNED_ITEM: 'partner-cohort-content-assigned-item',
            CONTENT_ASSIGNED_STATE: 'partner-cohort-content-assigned-state',
            CONTENT_ASSIGNABLE_ERROR: 'partner-cohort-content-assignable-error',
            CONTENT_REVOKE_BUTTON: 'partner-cohort-content-revoke-btn',
            CONTENT_TIMING_DROPDOWN: 'partner-cohort-content-timing-dropdown',
            CONTENT_TIMING_OPTION: 'partner-cohort-content-timing-option',
            CONTENT_TIMING_DATE_INPUT: 'partner-cohort-content-timing-date-input',
            LOAD_MORE_BUTTON: 'partner-cohorts-load-more-btn',
            LOAD_MORE_RETRY_BUTTON: 'partner-cohorts-load-more-retry-btn',
            MEMBERS_LOAD_ERROR: 'partner-cohort-members-load-error',
            MEMBERS_EMPTY_STATE: 'partner-cohort-members-empty-state',
            MEMBERS_LOAD_RETRY: 'partner-cohort-members-load-retry',
            MEMBERS_LOAD_MORE_BUTTON: 'partner-cohort-members-load-more-btn',
            MEMBERS_LOAD_MORE_RETRY_BUTTON: 'partner-cohort-members-load-more-retry-btn',
            MEMBER_ASSIGN_BUTTON: 'partner-cohort-member-assign-btn',
            DETAIL_LOAD_ERROR: 'partner-cohort-detail-load-error',
            DETAIL_LOAD_RETRY: 'partner-cohort-detail-load-retry',
            DETAIL_NOT_FOUND: 'partner-cohort-detail-not-found',
            MEMBER_ASSIGN_DIALOG: 'partner-cohort-member-assign-dialog',
            MEMBER_ASSIGN_SCOPE_DROPDOWN: 'partner-cohort-member-assign-scope-dropdown',
            MEMBER_ASSIGN_SCOPE_OPTION: 'partner-cohort-member-assign-scope-option',
            MEMBER_ASSIGN_TIMING_DROPDOWN: 'partner-cohort-member-assign-timing-dropdown',
            MEMBER_ASSIGN_TIMING_DATE_INPUT: 'partner-cohort-member-assign-timing-date-input',
            MEMBER_ASSIGN_SUBMIT_BUTTON: 'partner-cohort-member-assign-submit-btn',
            MEMBER_ASSIGN_EMPTY_HINT: 'partner-cohort-member-assign-empty-hint',
            MEMBER_GRANT_ITEM: 'partner-cohort-member-grant-item',
            MEMBER_GRANT_REVOKE_BUTTON: 'partner-cohort-member-grant-revoke-btn',
        },
        SETTINGS: {
            PAGE: 'partner-settings-page',
            TITLE: 'partner-settings-title',
            DESCRIPTION_INPUT: 'partner-settings-description-input',
            CONTACT_EMAIL_INPUT: 'partner-settings-contact-email-input',
            LOGO_URL_INPUT: 'partner-settings-logo-url-input',
            SAVE_BUTTON: 'partner-settings-save-button',
            ACCOUNT_LICENSE_SECTION: 'partner-settings-account-license-section',
            ACCOUNT_LICENSE_TYPE: 'partner-settings-account-license-type',
            ACCOUNT_LICENSE_STATUS: 'partner-settings-account-license-status',
            LOGOUT_BUTTON: 'partner-settings-logout-button',
        },
        MEMBERS: {
            PAGE: 'partner-members-page',
            TITLE: 'partner-members-title',
            INVITE_BUTTON: 'partner-members-invite-button',
            TABLE: 'partner-members-table',
            EMPTY_STATE: 'partner-members-empty-state',
            MEMBER_EMAIL: 'partner-members-member-email',
            MEMBER_STATUS: 'partner-members-member-status',
            INVITE_DIALOG: 'partner-members-invite-dialog',
            INVITE_EMAIL_INPUT: 'partner-members-invite-email-input',
            INVITE_FIRST_NAME_INPUT: 'partner-members-invite-first-name-input',
            INVITE_LAST_NAME_INPUT: 'partner-members-invite-last-name-input',
            INVITE_COHORT_DROPDOWN: 'partner-members-invite-cohort-dropdown',
            INVITE_COHORT_LOAD_INCOMPLETE: 'partner-members-invite-cohort-load-incomplete',
            INVITE_COHORT_LOAD_RETRY: 'partner-members-invite-cohort-load-retry',
            INVITE_SUBMIT_BUTTON: 'partner-members-invite-submit-button',
            RESEND_INVITE_ACTION: 'partner-members-resend-invite-action',
            DEACTIVATE_ACTION: 'partner-members-deactivate-action',
            REACTIVATE_ACTION: 'partner-members-reactivate-action',
            REMOVE_ACTION: 'partner-members-remove-action',
            CONTENT_ACTION: 'partner-members-content-action',
            CONFIRM_DIALOG: 'partner-members-confirm-dialog',
            CONFIRM_BUTTON: 'partner-members-confirm-button',
            REMOVE_MANAGER: {
                DIALOG: 'partner-members-remove-manager-dialog',
                CONFIRM_BUTTON: 'partner-members-remove-manager-confirm-button',
                ROLE_DROPDOWN: 'partner-members-remove-manager-role-dropdown',
            },
            LOAD_MORE_BUTTON: 'partner-members-load-more-button',
            LOAD_MORE_RETRY_BUTTON: 'partner-members-load-more-retry-button',
        },
        ANALYTICS: {
            PAGE: 'partner-analytics-page',
            TITLE: 'partner-analytics-title',
            TAB_DASHBOARD: 'partner-analytics-tab-dashboard',
            TAB_REPORTS: 'partner-analytics-tab-reports',
            WINDOW_LAST_7_DAYS: 'partner-analytics-window-LAST_7_DAYS',
            WINDOW_LAST_30_DAYS: 'partner-analytics-window-LAST_30_DAYS',
            WINDOW_LAST_90_DAYS: 'partner-analytics-window-LAST_90_DAYS',
            WINDOW_ALL_TIME: 'partner-analytics-window-ALL_TIME',
            ACTIVE_MEMBERS_CARD: 'partner-analytics-active-members',
            ACTIVE_IN_WINDOW_CARD: 'partner-analytics-active-in-window',
            START_RATE_CARD: 'partner-analytics-start-rate',
            COMPLETION_RATE_CARD: 'partner-analytics-completion-rate',
            REPORT_PROGRESS_COMPLETION_DOWNLOAD: 'partner-report-progress-completion-download',
            REPORT_SEAT_UTILIZATION_DOWNLOAD: 'partner-report-seat-utilization-download',
            REPORT_COHORT_COMPARISON_DOWNLOAD: 'partner-report-cohort-comparison-download',
            REPORT_WORKSHOP_ATTENDANCE_DOWNLOAD: 'partner-report-workshop-attendance-download',
            REPORT_FILTER_WORKSHOPS: 'partner-report-filter-workshops',
            REPORT_FILTERS_PANEL: 'partner-report-filters-panel',
            REPORT_FILTERS_CLEAR: 'partner-report-filters-clear',
            REPORT_FILTER_DATE_FROM: 'partner-report-filter-date-from',
            REPORT_FILTER_DATE_TO: 'partner-report-filter-date-to',
            REPORT_COHORT_LOAD_INCOMPLETE: 'partner-report-cohort-load-incomplete',
            REPORT_COHORT_LOAD_RETRY: 'partner-report-cohort-load-retry',
            REPORT_WORKSHOP_LOAD_INCOMPLETE: 'partner-report-workshop-load-incomplete',
            REPORT_WORKSHOP_LOAD_RETRY: 'partner-report-workshop-load-retry',
        },
        ACTIVITY: {
            CARD: 'partner-activity-card',
            EVENT_ROW: 'partner-activity-event-row',
            EVENT_TITLE: 'partner-activity-event-title',
        },
        SIDEBAR: {
            DASHBOARD: 'sidebar-partner-dashboard',
            MEMBERS: 'sidebar-partner-members',
            COHORTS: 'sidebar-partner-cohorts',
            LICENSE: 'sidebar-partner-license',
            BILLING: 'sidebar-partner-billing',
            ANALYTICS: 'sidebar-partner-analytics',
            SETTINGS: 'sidebar-partner-settings',
        },
        NOTIFICATIONS: {
            TRIGGER: 'partner-notifications-trigger',
            TABS: 'partner-notification-tabs',
            ITEM: 'partner-notification-item',
            TAB_ALERTS: 'partner-notification-tab-alerts',
        },
    },
    COMMUNITY: {
        PAGE: 'community-page',
        FEED: 'community-feed',
        POST_CARD: 'community-post-card',
        POST_CARD_LIKE_BUTTON: 'community-post-like-btn',
        POST_CARD_LIKE_COUNT: 'community-post-like-count',
        POST_CARD_COMMENT_TOGGLE: 'community-post-comment-toggle',
        POST_CARD_COMMENT_COUNT: 'community-post-comment-count',
        POST_CARD_SHARE_BUTTON: 'community-post-share-btn',
        POST_CARD_REPORT_BUTTON: 'community-post-report-btn',
        POST_CARD_MENU_TRIGGER: 'community-post-menu-trigger',
        /** @deprecated Use POST_CARD_MENU_TRIGGER — overflow menu is not report-specific. */
        POST_CARD_REPORT_TRIGGER: 'community-post-menu-trigger',
        POST_CARD_MENU_REPLY: 'community-post-menu-reply',
        POST_CARD_MENU_BOOKMARK: 'community-post-menu-bookmark',
        POST_CARD_MENU_SHARE: 'community-post-menu-share',
        POST_CARD_MENU_EDIT: 'community-post-menu-edit',
        POST_CARD_MENU_REPORT: 'community-post-menu-report',
        POST_CARD_MENU_DELETE: 'community-post-menu-delete',
        /** The moderation pin/unpin entry in a post card's overflow menu. */
        POST_CARD_MENU_PIN: 'community-post-menu-pin',
        /** Present on a card only while the post is pinned. */
        POST_CARD_PINNED_INDICATOR: 'community-post-pinned-indicator',
        /** @deprecated Use POST_CARD_MENU_EDIT. */
        POST_CARD_EDIT_TRIGGER: 'community-post-menu-edit',
        POST_CARD_REPORT_REASON_SELECT: 'community-post-report-reason',
        POST_CARD_REPORT_SUBMIT: 'community-post-report-submit',
        COMMENT_INPUT: 'community-comment-input',
        COMMENT_EDIT_INPUT: 'community-comment-edit-input',
        COMMENT_SUBMIT: 'community-comment-submit',
        COMMENT_FILE_INPUT: 'community-comment-file-input',
        /** A card's reply thread: the list, its loading, empty and failed states, and the composer. */
        POST_CARD_COMMENTS: 'community-post-card-comments',
        COMMENT_ITEM: 'community-comment-item',
        ADD_POST_TRIGGER: 'community-add-post-trigger',
        /** The opened composer: its fields, its actions and whatever blocks submitting. */
        ADD_POST_PANEL: 'community-add-post-panel',
        ADD_POST_TYPE_TEXT: 'community-add-post-type-text',
        ADD_POST_TYPE_LINK: 'community-add-post-type-link',
        ADD_POST_TYPE_IMAGE: 'community-add-post-type-image',
        ADD_POST_TITLE_INPUT: 'community-add-post-title',
        ADD_POST_BODY_INPUT: 'community-add-post-body',
        ADD_POST_SUBMIT: 'community-add-post-submit',
        /** Wrapper around the composer's country control, so its own chip is addressable. */
        ADD_POST_COUNTRY_FIELD: 'community-add-post-country-field',
        CHANNEL_ITEM: 'community-channel-item',
        CHANNEL_GROUP: 'community-channel-group',
        CHANNEL_GROUP_HEADING: 'community-channel-group-heading',
        CHANNEL_EXTERNAL_LINK: 'community-channel-external-link',
        CHANNEL_SIDEBAR_TOGGLE: 'community-channel-sidebar-toggle',
        CHANNEL_ALL_POSTS: 'community-channel-all-posts',
        CHANNEL_IDENTITY: 'community-channel-identity',
        CHANNEL_BANNER: 'community-channel-banner',
        START_HERE_HEADER: 'community-start-here-header',
        START_HERE_MEMBER_STACK: 'community-start-here-member-stack',
        START_HERE_NEW_POST: 'community-start-here-new-post',
        START_HERE_OPTIONS: 'community-start-here-options',
        START_HERE_BANNER: 'community-start-here-banner',
        START_HERE_BANNER_INPUT: 'community-start-here-banner-input',
        START_HERE_WELCOME_POST: 'community-start-here-welcome-post',
        START_HERE_STEP_GRID: 'community-start-here-step-grid',
        START_HERE_STEP_CARD: 'community-start-here-step-card',
        START_HERE_STEP_LINK: 'community-start-here-step-link',
        START_HERE_STEP_CTA: 'community-start-here-step-cta',
        EMPTY_STATE: 'community-feed-empty-state',
        /** The feed's own first-load placeholder, before any post has been rendered. */
        FEED_LOADING: 'community-feed-loading',
        /** The feed's own failed first load, with its retry control. */
        FEED_ERROR: 'community-feed-error',
        LOAD_SENTINEL: 'community-feed-load-sentinel',
        END_OF_FEED: 'community-feed-end',
        COMMENT_MENU_TRIGGER: 'community-comment-menu-trigger',
        COMMENT_MENU_EDIT: 'community-comment-menu-edit',
        COMMENT_MENU_REPORT: 'community-comment-menu-report',
        COMMENT_EDIT_DIALOG: 'community-comment-edit-dialog',
        COMMENT_EDIT_BOLD: 'community-comment-edit-bold',
        COMMENT_EDIT_SAVE: 'community-comment-edit-save',
        COMMENT_CONTENT: 'community-comment-content',
        COMMENT_BOLD_TEXT: 'community-comment-bold-text',
        REPORT_REASON_OPTION: 'community-report-reason-option',
        ADD_POST_QUICK_ACTION: 'community-add-post-quick-action',
        ADD_POST_ATTACH_FILE: 'community-add-post-attach-file',
        ADD_POST_FILE_INPUT: 'community-add-post-file-input',
        INTELLIGENCE_PANEL: 'community-intelligence-panel',
        INTELLIGENCE_PANEL_TRENDING_TAG: 'community-intelligence-panel-trending-tag',
        /** The two windows the trending discussions widget can be read in. */
        INTELLIGENCE_PANEL_TRENDING_TODAY: 'community-intelligence-panel-trending-today',
        INTELLIGENCE_PANEL_TRENDING_WEEK: 'community-intelligence-panel-trending-week',
        POST_DETAIL_PAGE: 'community-post-detail-page',
        /** The detail page's own spinner, which the route's shared one is not. */
        POST_DETAIL_LOADING: 'community-post-detail-loading',
        /** The opened report form: its reasons, its optional details and its actions. */
        POST_CARD_REPORT_PANEL: 'community-post-report-panel',
        POST_CARD_REPORT_DETAILS: 'community-post-report-details',
        POST_CARD_BODY: 'community-post-card-body',
        POST_CARD_READ_MORE: 'community-post-card-read-more',
        POST_CARD_AUTHOR_HEADLINE: 'community-post-card-author-headline',
        /** The card's own image block, rendered only for a post that carries a picture. */
        POST_CARD_MEDIA: 'community-post-card-media',
        /**
         * Rich media of a post, on every surface the shared card renders on.
         *
         * A player wraps whichever provider the body or an attachment named, so the
         * video id travels on `data-video-id` and the provider on `data-provider`.
         * The gallery is one block for a run of images, whether they came from the
         * body or from the post's image attachments: `GALLERY_ITEM` is a visible
         * tile, `GALLERY_OVERFLOW` is the "+N more" tile, and the dialog is what
         * opening a tile shows.
         */
        POST_MEDIA_VIDEO: 'community-post-media-video',
        POST_MEDIA_VIDEO_CAPTION: 'community-post-media-video-caption',
        POST_MEDIA_GALLERY: 'community-post-media-gallery',
        POST_MEDIA_GALLERY_ITEM: 'community-post-media-gallery-item',
        POST_MEDIA_GALLERY_IMAGE: 'community-post-media-gallery-image',
        POST_MEDIA_GALLERY_OVERFLOW: 'community-post-media-gallery-overflow',
        POST_MEDIA_GALLERY_DIALOG: 'community-post-media-gallery-dialog',
        POST_MEDIA_GALLERY_DIALOG_IMAGE: 'community-post-media-gallery-dialog-image',
        POST_MEDIA_GALLERY_DIALOG_COUNTER: 'community-post-media-gallery-dialog-counter',
        POST_MEDIA_GALLERY_DIALOG_NEXT: 'community-post-media-gallery-dialog-next',
        POST_MEDIA_GALLERY_DIALOG_PREVIOUS: 'community-post-media-gallery-dialog-previous',
        POST_CARD_TITLE_LINK: 'community-post-card-title-link',
        MEMBERS_PAGE: 'community-members-page',
        MEMBERS_SEARCH: 'community-members-search',
        MEMBERS_LAYOUT_TOGGLE: 'community-members-layout-toggle',
        MEMBERS_FILTERS: 'community-members-filters',
        MEMBERS_CARD: 'community-members-card',
        MEMBERS_PROFILE_LINK: 'community-members-profile-link',
        MEMBERS_CONNECTION_ACTION: 'community-members-connection-action',
        MEMBERS_DECLINE_ACTION: 'community-members-decline-action',
        MEMBERS_SCOPE: 'community-members-scope',
        MEMBERS_EMPTY: 'community-members-empty',
        MEMBER_PROFILE_PAGE: 'community-member-profile-page',
        MEMBER_PROFILE_HEADER: 'community-member-profile-header',
        MEMBER_PROFILE_TABS: 'community-member-profile-tabs',
        MEMBER_PROFILE_PANEL: 'community-member-profile-panel',
        MEMBER_PROFILE_TAB: 'community-member-profile-tab',
        MEMBER_PROFILE_MORE: 'community-member-profile-more',
        MEMBER_PROFILE_RETRY: 'community-member-profile-retry',
        MEMBERS_MORE: 'community-members-more',
        /** The one country flag a tagged post card shows; a global post shows none. */
        POST_CARD_COUNTRY_FLAG: 'community-post-card-country-flag',
        POST_EDIT_SAVE: 'community-post-edit-save',
        POST_EDIT_COUNTRY_FIELD: 'community-post-edit-country-field',
        COMMENT_LOAD_MORE: 'community-comment-load-more',
        COMMENT_THREAD_LOADING: 'community-comment-thread-loading',
        COMMENT_THREAD_EMPTY: 'community-comment-thread-empty',
        COMMENT_THREAD_ERROR: 'community-comment-thread-error',
        COMMENT_THREAD_RETRY: 'community-comment-thread-retry',
        COMMENT_NEXT_PAGE_ERROR: 'community-comment-next-page-error',
        COMMENT_LIKE: 'community-comment-like',
        COMMENT_LIKE_COUNT: 'community-comment-like-count',
        COMMENT_REPLY: 'community-comment-reply',
        COMMENT_MENU_DELETE: 'community-comment-menu-delete',
        COMMENT_DELETE_CONFIRM: 'community-comment-delete-confirm',
        COMMENT_REPLY_TARGET: 'community-comment-reply-target',
        COMMENT_REPLY_CANCEL: 'community-comment-reply-cancel',
    },
};
//# sourceMappingURL=data-test-ids.js.map